// English interface strings, keyed by the French source text. Missing keys fall back to French.
const en: Record<string, string> = {
  'Ressource introuvable ou réservation indisponible.':
    'Resource not found or unavailable for booking.',
  'Choisissez entre 1 et 100 occurrences.': 'Choose between 1 and 100 occurrences.',
  'Les occurrences de cette réunion se chevauchent.': 'The occurrences of this meeting overlap.',
  'Cette ressource est déjà réservée sur au moins un créneau de la réunion.':
    'This resource is already booked during at least one occurrence of the meeting.',
  'Cette réservation est liée à une réunion. Modifiez ou annulez la réunion pour libérer la ressource.':
    'This booking is linked to a meeting. Edit or cancel the meeting to release the resource.',
  'Ressource réservée': 'Reserved resource',
  'Ressource indisponible': 'Resource unavailable',
  'Salle ou équipement à réserver': 'Room or equipment to book',
  'Aucune ressource': 'No resource',
  'La ressource suit les horaires, les exceptions et l’annulation de la réunion. Un conflit empêche l’enregistrement et l’envoi des invitations.':
    'The resource follows the meeting times, exceptions and cancellation. A conflict prevents saving the meeting and sending invitations.',
  'Réservation liée à une réunion : modifiez ou annulez la réunion pour changer ce créneau.':
    'Booking linked to a meeting: edit or cancel the meeting to change this time slot.',
  'Trop de réservations. Choisissez une période plus courte.':
    'Too many bookings. Choose a shorter date range.',
  'Cette réservation a déjà été annulée.': 'This booking has already been cancelled.',
  'Cette clé de requête a déjà servi à une autre réservation.':
    'This request key has already been used for another booking.',

  'Calendrier introuvable.': 'Calendar not found.',
  'Révoquez un abonnement avant d’en créer un nouveau.':
    'Revoke a subscription before creating another one.',
  'Abonnement introuvable.': 'Subscription not found.',
  'Trop d’événements pour cet abonnement.': 'Too many events for this subscription.',
  'Occurrence exceptionnelle inconnue ou répétée.': 'Unknown or duplicate occurrence exception.',
  'Début et fin requis pour déplacer une occurrence.':
    'A start and end time are required to move an occurrence.',
  'Fin exceptionnelle invalide.': 'Invalid end time for the occurrence exception.',
  'Annulez la série pour supprimer toutes ses occurrences.':
    'Cancel the series to remove all its occurrences.',
  'Trop d’événements. Choisissez une période plus courte.':
    'Too many events. Choose a shorter date range.',
  'Trop d’occurrences. Choisissez une période plus courte.':
    'Too many occurrences. Choose a shorter date range.',
  'Cette fonction est réservée aux boîtes partagées.':
    'This feature is only available for shared mailboxes.',
  'Cette conversation est trop volumineuse.': 'This conversation is too large.',
  'Les fonctions Pro ne sont pas activées.': 'Pro features are not enabled.',
  'Choisissez une période de 93 jours maximum.': 'Choose a date range of no more than 93 days.',
  'Ressource introuvable.': 'Resource not found.',
  'Une réservation doit durer entre une minute et 7 jours.':
    'A booking must last between one minute and 7 days.',
  'Cette ressource est déjà réservée sur ce créneau.':
    'This resource is already booked for that time slot.',
  'Réservation introuvable.': 'Booking not found.',
  'Seul le réservant ou un administrateur peut annuler.':
    'Only the person who made the booking or an administrator can cancel it.',
  'La réservation a changé. Actualisez.': 'The booking has changed. Refresh the page.',
  'Cet événement ne possède pas d’organisateur.': 'This event does not have an organizer.',
  'Événement transféré. Actualisez le calendrier.':
    'The event has been transferred. Refresh the calendar.',
  'Événement annulé ou remplacé.': 'The event has been cancelled or replaced.',
  'Seul l’organisateur ou son délégué peut modifier les invitations.':
    'Only the organizer or their delegate can change the invitations.',
  'L’organisateur est inactif. Transférez cet événement avant de le modifier.':
    'The organizer is inactive. Transfer this event before changing it.',
  'Événement modifié. Actualisez le calendrier.': 'The event has changed. Refresh the calendar.',
  'Seul l’organisateur peut choisir ses délégués.':
    'Only the organizer can appoint their delegates.',
  'Le transfert nécessite l’organisateur ou un administrateur du calendrier.':
    'Only the organizer or a calendar administrator can transfer the event.',
  'Choisissez une autre personne.': 'Choose another person.',
  'La personne doit avoir un compte actif et un accès en modification au calendrier.':
    'The person must have an active account and write access to the calendar.',
  'Maximum 20 délégués par événement.': 'A maximum of 20 delegates is allowed per event.',
  Répétition: 'Repeat',
  'Une seule fois': 'Once',
  'Nombre d’occurrences': 'Number of occurrences',
  '100 occurrences maximum. Les exceptions sont conservées lors de la modification de la série.':
    'A maximum of 100 occurrences. Exceptions are preserved when you edit the series.',
  'Une réponse est déjà en préparation par': 'A reply is already being drafted by',
  'Coordonnez-vous avant l’envoi pour éviter une double réponse.':
    'Coordinate before sending to avoid duplicate replies.',
  'La présence des autres rédacteurs est momentanément indisponible.':
    'Other users’ drafting status is temporarily unavailable.',
  'Salles et équipements': 'Rooms and equipment',
  'Réservez une ressource pour votre équipe. Deux réservations ne peuvent pas se chevaucher.':
    'Book a resource for your team. Bookings cannot overlap.',
  'Nom de la ressource': 'Resource name',
  Type: 'Type',
  Salle: 'Room',
  Équipement: 'Equipment',
  'Ajouter la ressource': 'Add resource',
  'Choisir une ressource': 'Choose a resource',
  'Objet de la réservation': 'Booking title',
  'Début de la réservation': 'Booking start',
  'Fin de la réservation': 'Booking end',
  'Réserver ce créneau': 'Book this time slot',
  'Réservations des 90 prochains jours': 'Bookings for the next 90 days',
  'Aucune réservation sur cette période.': 'No bookings in this date range.',
  'Annuler la réservation': 'Cancel booking',
  'Afficher l’agenda dans Outlook ou Thunderbird': 'View the calendar in Outlook or Thunderbird',
  'Abonnement en lecture seule au calendrier sélectionné. Modifiez vos événements dans Vename Mail. La fréquence d’actualisation dépend du client.':
    'Read-only subscription to the selected calendar. Edit your events in Vename Mail. Refresh frequency depends on your calendar app.',
  'Sélectionnez un calendrier d’équipe.': 'Select a team calendar.',
  'Créer un lien d’abonnement privé': 'Create a private subscription link',
  'Ce lien donne accès aux événements. Conservez-le comme un mot de passe. Il expire après un an et peut être révoqué.':
    'This link provides access to events. Keep it as private as a password. It expires after one year and can be revoked.',
  'Lien iCalendar': 'iCalendar link',
  'Outlook : Ajouter un calendrier → S’abonner à partir du web. Thunderbird : Nouveau calendrier → Sur le réseau → iCalendar (ICS).':
    'Outlook: Add calendar → Subscribe from web. Thunderbird: New Calendar → On the Network → iCalendar (ICS).',
  'Le flux inclut les 90 derniers jours et les 365 prochains jours.':
    'The feed includes the previous 90 days and the next 365 days.',
  'Révoquer cet abonnement': 'Revoke this subscription',
  'Date ou heure invalide.': 'Invalid date or time.',
  'Événement récurrent : les modifications ci-dessous concernent uniquement cette occurrence.':
    'Recurring event: the changes below apply only to this occurrence.',
  'Annuler cette occurrence': 'Cancel this occurrence',
  'Déplacer cette occurrence': 'Move this occurrence',
  'Nouveau début': 'New start',
  'Nouvelle fin': 'New end',
  'Enregistrer le déplacement': 'Save rescheduling',
  'Organisation et délégation': 'Organizer and delegation',
  'Les délégués peuvent modifier et annuler les invitations au nom de l’organisateur.':
    'Delegates can change and cancel invitations on behalf of the organizer.',
  'Ancien délégué': 'Former delegate',
  'Retirer la délégation': 'Remove delegation',
  'Personne autorisée': 'Authorized person',
  'Choisir une personne': 'Choose a person',
  'Ajouter un délégué': 'Add a delegate',
  'Transférer l’organisation': 'Transfer organizer role',
  'Le transfert annule les anciennes invitations et envoie une nouvelle invitation depuis le nouveau compte. Les invités devront répondre à nouveau.':
    'The transfer cancels the previous invitations and sends a new invitation from the new account. Guests will need to respond again.',
  'Confirmer le transfert et inviter': 'Confirm transfer and invite',
  Retour: 'Back',
  'La récurrence des événements d’équipe n’est pas encore disponible.':
    'Team event recurrence is not available yet.',
  'Seul l’organisateur peut modifier un événement avec invitations.':
    'Only the organizer can change an event with invitations.',
  'Les événements avec invitations utilisent une précision à la minute.':
    'Events with invitations use minute precision.',
  'Votre accès en modification au calendrier d’équipe a été retiré.':
    'Your write access to the team calendar has been revoked.',
  'Réponses des invités': 'Guest responses',
  Acceptée: 'Accepted',
  Refusée: 'Declined',
  'Invitations : {sent} transmise(s), {pending} en attente':
    'Invitations: {sent} sent, {pending} pending',
  'Les invités recevront une invitation depuis votre adresse email.':
    'Guests will receive an invitation from your email address.',

  'En cours': 'Ongoing',
  'Traitement en cours…': 'Processing…',
  'Date invalide.': 'Invalid date.',
  'Les disponibilités se consultent sur 7 jours maximum.':
    'Availability can be queried for at most 7 days.',
  'Trop de créneaux à consulter. Choisissez une période plus courte.':
    'Too many busy periods. Choose a shorter date range.',
  'Disponibilités de l’équipe': 'Team availability',
  'Partagez uniquement vos créneaux occupés. Les titres et descriptions de votre agenda personnel restent privés.':
    'Share only your busy periods. Personal event titles and descriptions remain private.',
  'Partager mes disponibilités avec mon organisation': 'Share my availability with my organization',
  'Membres à réunir (20 maximum)': 'Meeting participants (maximum 20)',
  'Jour de la réunion': 'Meeting date',
  'Durée de la réunion': 'Meeting duration',
  '{minutes} minutes': '{minutes} minutes',
  'Chercher des créneaux': 'Find meeting times',
  'Disponibilités non partagées': 'Availability not shared',
  'Aucun créneau occupé ce jour': 'No busy periods on this day',
  'Tous les membres sélectionnés doivent partager leurs disponibilités pour proposer un créneau commun.':
    'All selected members must share their availability to suggest a common meeting time.',
  'Créneaux communs entre 08 h et 18 h': 'Common times between 8 am and 6 pm',
  'Heures affichées dans votre fuseau local. Ces propositions ne réservent pas les agendas.':
    'Times are shown in your local timezone. Suggestions do not reserve calendar time.',
  'Aucun créneau commun pour cette durée.': 'No common time for this duration.',
  'Date à consulter': 'Calendar date',
  'Vue du calendrier d’équipe': 'Team calendar view',
  'Heures affichées dans votre fuseau local.': 'Times are shown in your local timezone.',
  'Chargement des événements…': 'Loading events…',
  'Événements du calendrier d’équipe': 'Team calendar events',
  'Créer un événement le {date}': 'Create an event on {date}',
  'Aucun événement sur cette période.': 'No events in this period.',
  'Choisissez un calendrier modifiable pour préparer la réunion.':
    'Select a calendar you can edit to prepare the meeting.',
  '0 octet': '0 bytes',
  '1 heure': '1 hour',
  '1 jour': '1 day',
  '15 minutes': '15 minutes',
  '30 jours': '30 days',
  '7 jours': '7 days',
  '90 jours': '90 days',
  '180 jours': '180 days',
  '360 jours': '360 days',
  AGENDA: 'AGENDA',
  Absence: 'Out of office',
  'Accès révoqué.': 'Access revoked.',
  Actions: 'Actions',
  'Activer la règle {name}': 'Enable rule {name}',
  'Activer la réponse d’absence': 'Enable the out-of-office reply',
  'Actualiser les messages': 'Refresh messages',
  Administration: 'Administration',
  'Administration Vename Mail': 'Vename Mail administration',
  'Adresse email': 'Email address',
  'Adresse professionnelle': 'Work email address',
  'Afficher la version texte': 'Show plain text',
  'Afficher le contenu enrichi': 'Show rich content',
  'Afficher les en-têtes': 'Show headers',
  'Afficher les favoris': 'Show starred',
  'Afficher les messages suivants': 'Show more messages',
  Agenda: 'Calendar',
  'Ajouter aux favoris': 'Add to starred',
  'Ajouter cette adresse': 'Add this address',
  'Ajouter des invités': 'Add guests',
  'Ajouter un lieu': 'Add a location',
  'Ajouter un titre': 'Add a title',
  'Ajouter une condition': 'Add a condition',
  'Ajouter une description': 'Add a description',
  'Ajoutez au moins un destinataire.': 'Add at least one recipient.',
  'Aller au contenu': 'Skip to content',
  'Analyse en attente': 'Scan pending',
  'Analyse terminée': 'Scan complete',
  Annuler: 'Cancel',
  'Annuler cet envoi': 'Cancel this send',
  'Annuler la programmation': 'Cancel scheduling',
  'Annuler l’envoi': 'Cancel send',
  'Annuler l’envoi de {subject}': 'Cancel sending {subject}',
  'Annuler l’événement': 'Cancel the event',
  'Aperçu de la signature': 'Signature preview',
  'Appareil mobile': 'Mobile device',
  'Applications de messagerie': 'Mail applications',
  'Archiver la sélection': 'Archive selection',
  'Archiver le message': 'Archive message',
  'Au moins une condition': 'At least one condition',
  Aucun: 'None',
  'Aucun domaine': 'No domain',
  'Aucun contact ne correspond à cette recherche.': 'No contact matches this search.',
  'Aucun envoi programmé.': 'No scheduled send.',
  'Aucun résultat': 'No results',
  'Aucune règle définie. Vos messages arrivent tous dans la boîte de réception.':
    'No rule defined. All your messages land in the inbox.',
  'Aucune signature pour le moment.': 'No signature yet.',
  'Aucune suggestion. Vous pouvez ajouter une adresse complète.':
    'No suggestion. You can add a full address.',
  'Aujourd’hui': 'Today',
  'Bienvenue chez vous': 'Welcome home',
  'Bloquées pour protéger votre confidentialité et économiser les données.':
    'Blocked to protect your privacy and save data.',
  'Bonjour, je suis absent(e) jusqu’au … Je vous répondrai à mon retour.':
    'Hello, I am away until … I will reply when I am back.',
  'Boîte de réception': 'Inbox',
  'Boîte ouverte': 'Mailbox in use',
  'Brouillon conservé dans cet onglet': 'Draft kept in this tab',
  'COMME VOUS L’AIMEZ': 'THE WAY YOU LIKE IT',
  'Carnet d’adresses': 'Address book',
  Cc: 'Cc',
  'Cc / Cci': 'Cc / Bcc',
  Cci: 'Bcc',
  'Ce dossier ne contient aucun message pour le moment.': 'This folder has no message yet.',
  'Centre d’aide': 'Help centre',
  'Cet appareil': 'This device',
  'Champ de la condition {n}': 'Field of condition {n}',
  'Chaque jour': 'Every day',
  'Chaque mois': 'Every month',
  'Chaque semaine': 'Every week',
  'Chargement de la réponse d’absence…': 'Loading the out-of-office reply…',
  'Chargement de l’agenda…': 'Loading the calendar…',
  'Chargement des envois programmés…': 'Loading scheduled sends…',
  'Chargement des règles…': 'Loading rules…',
  'Chargement du carnet…': 'Loading the address book…',
  'Chargement…': 'Loading…',
  'Choisissez une heure d’envoi dans au moins une minute.':
    'Choose a send time at least one minute from now.',
  'Classer dans un dossier': 'File into a folder',
  'Code de vérification': 'Verification code',
  'Compte d’administration sans boîte mail. Aucune unité de messagerie consommée.':
    'Administration account without a mailbox. No mail unit consumed.',
  Conditions: 'Conditions',
  'Connectez-vous à votre messagerie professionnelle.': 'Sign in to your work mailbox.',
  'Connexion interrompue. Vos modifications restent dans cet onglet.':
    'Connection lost. Your changes stay in this tab.',
  'Se connecter à Vename Mail': 'Sign in to Vename Mail',
  Conserver: 'Keep',
  'Conservez votre accès d’application': 'Keep your application access',
  'Console Vename': 'Vename console',
  'Consultez l’état de votre envoi.': 'Check the status of your send.',
  'Contact ajouté à votre carnet.': 'Contact added to your address book.',
  'Contact mis à jour.': 'Contact updated.',
  'Contact supprimé.': 'Contact deleted.',
  'Contenu enrichi du message': 'Rich content of the message',
  'Copier le secret': 'Copy the secret',
  'Copier le texte du message': 'Copy the message text',
  'Corps du message': 'Message body',
  'Créer le {day} à {hour}:00': 'Create on {day} at {hour}:00',
  'Créer un accès d’application': 'Create an application access',
  'Créer un dossier': 'Create a folder',
  'Créer un événement': 'Create an event',
  'C’est par ici': 'Start here',
  Date: 'Date',
  De: 'From',
  'De quoi souhaitez-vous parler ?': 'What would you like to talk about?',
  'Demain 8 h': 'Tomorrow 8 am',
  'Dernier envoi': 'Last send',
  'Dernière étape': 'Last step',
  'Descendre la règle {name}': 'Move rule {name} down',
  Description: 'Description',
  'Dossier de destination': 'Destination folder',
  'Dossier enregistré.': 'Folder saved.',
  'Dossier supprimé.': 'Folder deleted.',
  'Dossiers de messagerie': 'Mail folders',
  Droits: 'Rights',
  Durée: 'Duration',
  Début: 'Start',
  Déclenchement: 'Trigger',
  'Définissez un mot de passe pour activer votre compte.':
    'Set a password to activate your account.',
  'Déplacer le message': 'Move message',
  'Déplacer vers un dossier': 'Move to a folder',
  Désactiver: 'Disable',
  'Détails du rendez-vous': 'Appointment details',
  'Effacer la recherche': 'Clear search',
  'En attente': 'Pending',
  'En-têtes du message': 'Message headers',
  Enregistrer: 'Save',
  'Enregistrement…': 'Saving…',
  'Enregistrer et inviter': 'Save and invite',
  'Enregistrer les modifications': 'Save changes',
  'Enregistrer une copie distincte': 'Save as a separate copy',
  'Enregistré sur Vename Mail': 'Saved on Vename Mail',
  'Envoi (SMTP)': 'Sending (SMTP)',
  'Envoi annulé.': 'Send cancelled.',
  'Envoi en cours…': 'Sending…',
  'Envoi pris en charge par le serveur mail.': 'Send accepted by the mail server.',
  'Envoi programmé le {date}.': 'Send scheduled for {date}.',
  'Envois programmés.': 'Scheduled sends.',
  'Envoyer le': 'Send on',
  Envoyer: 'Send',
  'Espace local · Données fictives': 'Local environment · Sample data',
  'Espace professionnel': 'Workspace',
  'Espaces Vename Mail': 'Vename Mail spaces',
  'Essayez un autre mot ou ajustez vos filtres.': 'Try another word or adjust your filters.',
  'Exporter (vCard)': 'Export (vCard)',
  Expéditeur: 'Sender',
  Fermer: 'Close',
  'Fermer et conserver le brouillon': 'Close and keep the draft',
  'Fermer la navigation': 'Close navigation',
  'Fermer la notification': 'Close notification',
  'Fermer le rappel': 'Dismiss reminder',
  'Fermer le volet Agenda': 'Close the calendar panel',
  'Fermez ou enregistrez le message ouvert avant de changer de boîte.':
    'Close or save the open message before switching mailbox.',
  'Fermez votre brouillon pour l’enregistrer avant de vous déconnecter.':
    'Close your draft to save it before signing out.',
  'Fichier bloqué': 'File blocked',
  'Fichier local, non analysé': 'Local file, not scanned',
  'Filtres de recherche': 'Search filters',
  Fin: 'End',
  'Fuseau de l’événement': 'Event time zone',
  'Fuseau horaire': 'Time zone',
  'Départ le {date} ({zone}).': 'Departure on {date} ({zone}).',
  'Soit {date} sur cet appareil ({zone}).': 'That is {date} on this device ({zone}).',
  'Choisissez une date et une heure.': 'Pick a date and a time.',
  'Cet envoi n’est plus programmé : il est parti, a été annulé ou a échoué.':
    'This message is no longer scheduled: it has left, was cancelled or failed.',
  'Changer l’heure d’envoi de {subject}': 'Change the sending time of {subject}',
  'Changer l’heure d’envoi': 'Change the sending time',
  'Nouvelle heure d’envoi enregistrée.': 'New sending time saved.',
  'Enregistrer l’heure': 'Save the time',
  'Cette heure n’existe pas dans ce fuseau, à cause du changement d’heure.':
    'This time does not exist in this time zone because of the daylight saving change.',
  'Fuseau inconnu. Choisissez un fuseau de la liste.': 'Unknown time zone. Pick one from the list.',
  'Gardez vos codes de secours.': 'Keep your recovery codes.',
  'Gestion des messages (IMAP)': 'Message management (IMAP)',
  'Gestion des messages et envoi (IMAP et SMTP)': 'Message management and sending (IMAP and SMTP)',
  Gras: 'Bold',
  'Gérer le dossier': 'Manage folder',
  'Gérer le dossier {name}': 'Manage folder {name}',
  'Heureux de vous retrouver.': 'Good to see you again.',
  'Hors connexion': 'Offline',
  'Identifiants disponibles dans': 'Credentials available in',
  'Images distantes': 'Remote images',
  'Images distantes et contenus actifs bloqués.': 'Remote images and active content blocked.',
  'Images distantes et contenus actifs bloqués. Les images intégrées autorisées sont affichées.':
    'Remote images and active content are blocked. Allowed embedded images are displayed.',
  'Import en cours…': 'Importing…',
  'Import {format} terminé : {summary}.': '{format} import complete: {summary}.',
  'Importer (vCard, CSV)': 'Import (vCard, CSV)',
  'Informations sur ce dossier': 'About this folder',
  Italique: 'Italic',
  'Joindre des fichiers': 'Attach files',
  Jour: 'Day',
  'Jour précédent': 'Previous day',
  'Jour suivant': 'Next day',
  'Jusqu’au': 'Until',
  'Jusqu’à {time}': 'Until {time}',
  'J’ai conservé mes codes dans un endroit sûr.': 'I have stored my codes in a safe place.',
  'La double authentification est activée.': 'Two-factor authentication is enabled.',
  'Langue de l’interface': 'Interface language',
  'Le fichier dépasse 4 Mo : découpez votre carnet avant l’import.':
    'The file exceeds 4 MB: split your address book before importing.',
  'Lecture du message': 'Reading the message',
  'Les bonnes idées': 'Good ideas',
  'Les informations concernant vos envois apparaîtront ici.':
    'Information about your sends will appear here.',
  'Les messages sont conservés pendant 30 jours avant leur suppression.':
    'Messages are kept for 30 days before deletion.',
  'Les pièces jointes ne peuvent pas dépasser 18 Mio au total.':
    'Attachments cannot exceed 18 MiB in total.',
  Lieu: 'Location',
  'Liste des messages': 'Message list',
  'Liste à puces': 'Bulleted list',
  'Lundi 8 h': 'Monday 8 am',
  'MES DOSSIERS': 'MY FOLDERS',
  MESSAGERIE: 'MAIL',
  'MFA activé': 'MFA enabled',
  'Marquer comme lu': 'Mark as read',
  'Marquer comme non lu': 'Mark as unread',
  'Marquer la sélection comme lue': 'Mark selection as read',
  'Mes agendas': 'My calendars',
  Message: 'Message',
  'Message archivé.': 'Message archived.',
  'Message déplacé dans la corbeille.': 'Message moved to the bin.',
  'Message précédent': 'Previous message',
  'Message remis dans les boîtes locales.': 'Message delivered to local mailboxes.',
  'Message restauré dans la réception.': 'Message restored to the inbox.',
  'Message suivant': 'Next message',
  'Message transféré': 'Forwarded message',
  Messagerie: 'Mail',
  'Messagerie Vename Mail': 'Vename Mail',
  'Messagerie professionnelle': 'Business email',
  'Messages envoyés': 'Sent messages',
  'Messages mis à jour.': 'Messages updated.',
  'Mettre en favori': 'Star',
  'Mettre à la corbeille': 'Move to bin',
  'Mode d’envoi': 'Send mode',
  Modifier: 'Edit',
  'Modifier la règle': 'Edit rule',
  'Modifier la règle {name}': 'Edit rule {name}',
  'Modifier la série': 'Edit the series',
  'Modifier le brouillon': 'Edit draft',
  'Modifier le contact': 'Edit contact',
  'Modifier {name}': 'Edit {name}',
  'Modifier {subject}': 'Edit {subject}',
  Mois: 'Month',
  'Mon agenda': 'My calendar',
  'Mon ordinateur professionnel': 'My work computer',
  'Mon profil': 'My profile',
  'Monter la règle {name}': 'Move rule {name} up',
  'Mot de passe': 'Password',
  'Mot de passe oublié ou téléphone perdu ?': 'Forgotten password or lost phone?',
  'NOUVEL ÉVÉNEMENT': 'NEW EVENT',
  'Navigateur web': 'Web browser',
  'Navigation de l’agenda': 'Calendar navigation',
  'Ne pas appliquer les règles suivantes': 'Stop processing further rules',
  Nom: 'Name',
  'Nom affiché': 'Display name',
  'Nom de la règle': 'Rule name',
  'Nom de l’application': 'Application name',
  'Nom du dossier': 'Folder name',
  'Nom ou adresse email': 'Name or email address',
  'Nom, adresse ou société': 'Name, address or company',
  'Nombre de dates (max. 100)': 'Number of dates (max. 100)',
  Notes: 'Notes',
  Notifications: 'Notifications',
  'Nouveau contact': 'New contact',
  'Nouveau message': 'New message',
  'Nouveau mot de passe': 'New password',
  'Nouvel événement': 'New event',
  'Nouvelle règle': 'New rule',
  Objet: 'Subject',
  'Objet de la réponse': 'Reply subject',
  'Opérateur de la condition {n}': 'Operator of condition {n}',
  'Ouverture de votre espace…': 'Opening your workspace…',
  'Ouverture du message…': 'Opening the message…',
  'Ouvrir la navigation': 'Open navigation',
  'Ouvrir l’agenda complet': 'Open the full calendar',
  'Ouvrir ma messagerie': 'Open my mailbox',
  'Ouvrir mon profil': 'Open my profile',
  'PLACE À L’ESSENTIEL': 'FOCUS ON WHAT MATTERS',
  'Par Vename': 'By Vename',
  Paramètres: 'Settings',
  'Personnalisez vos messages et gardez le contrôle de votre accès.':
    'Personalise your messages and stay in control of your access.',
  'Pièce jointe {name} : {error}': 'Attachment {name}: {error}',
  'Plus d’actions sur le message': 'More message actions',
  'Plus d’options': 'More options',
  'Plus récents': 'Newest first',
  'Programmation annulée': 'Scheduling cancelled',
  'Programmation annulée : le brouillon est de nouveau modifiable.':
    'Scheduling cancelled: the draft can be edited again.',
  Programmer: 'Schedule',
  'Programmer l’envoi': 'Schedule send',
  Programmés: 'Scheduled',
  'Progression du téléversement': 'Upload progress',
  'Protégez votre compte.': 'Protect your account.',
  'Préparation de l’aperçu…': 'Preparing the preview…',
  'Préparation du second facteur…': 'Preparing the second factor…',
  'Préserver votre confidentialité': 'Protecting your privacy',
  'Période précédente': 'Previous period',
  'Période suivante': 'Next period',
  'Période terminée : la réponse n’est plus envoyée.': 'Period over: the reply is no longer sent.',
  Rappel: 'Reminder',
  'Recherche locale limitée aux 20 000 messages les plus récents.':
    'Local search limited to the 20,000 most recent messages.',
  'Recherche « {q} » dans votre boîte': 'Search “{q}” in your mailbox',
  'Rechercher dans mes messages': 'Search my messages',
  'Rechercher dans vos messages': 'Search your messages',
  'Rechercher un contact': 'Search contacts',
  'Remis localement': 'Delivered locally',
  'Restaurer dans la réception': 'Restore to inbox',
  'Retirer la condition {n}': 'Remove condition {n}',
  'Retirer le favori': 'Remove star',
  'Retrouver un échange': 'Find a conversation',
  'Revenir à la liste': 'Back to the list',
  'Revenir à l’agenda': 'Back to the calendar',
  'Rien de prévu sur ces sept jours.': 'Nothing planned over these seven days.',
  'Règle créée.': 'Rule created.',
  'Règle mise à jour.': 'Rule updated.',
  'Règle supprimée.': 'Rule deleted.',
  'Règles de tri': 'Sorting rules',
  Récurrence: 'Recurrence',
  'Rédiger un message': 'Write a message',
  'Réduire la fenêtre': 'Minimise window',
  Réessayer: 'Retry',
  'Réessayer le même envoi': 'Retry the same send',
  Réinitialiser: 'Reset',
  Répondre: 'Reply',
  'Répondre au message': 'Reply to the message',
  'Réponse d’absence active.': 'Out-of-office reply active.',
  'Réponse d’absence désactivée.': 'Out-of-office reply disabled.',
  'Réponse d’absence programmée.': 'Out-of-office reply scheduled.',
  'Résultats de recherche': 'Search results',
  Révoquer: 'Revoke',
  'Saisir la clé manuellement': 'Enter the key manually',
  'Saisissez un nom ou une adresse.': 'Type a name or an address.',
  'Saisissez une adresse email valide ou choisissez une suggestion.':
    'Enter a valid email address or pick a suggestion.',
  'Se connecter': 'Sign in',
  'Se déconnecter': 'Sign out',
  'Se déconnecter de cet appareil': 'Sign out of this device',
  'Secret copié.': 'Secret copied.',
  'Secret d’application': 'Application secret',
  Semaine: 'Week',
  'Session révoquée.': 'Session revoked.',
  'Si la condition correspond': 'If the condition matches',
  'Si les {n} conditions correspondent': 'If all {n} conditions match',
  'Si l’une des {n} conditions correspond': 'If any of the {n} conditions matches',
  'Signaler comme indésirable': 'Report as junk',
  'Signature personnelle': 'Personal signature',
  'Signature personnelle — aperçu': 'Personal signature — preview',
  Société: 'Company',
  Souligné: 'Underline',
  'Stockage utilisé': 'Storage used',
  'Suggestions d’invités': 'Guest suggestions',
  Supprimer: 'Delete',
  'Supprimer ce contact': 'Delete this contact',
  'Supprimer cette règle': 'Delete this rule',
  'Supprimer définitivement': 'Delete permanently',
  'Supprimer définitivement ce brouillon ?': 'Permanently delete this draft?',
  'Supprimer définitivement {n} message(s) ? Cette action est irréversible.':
    'Permanently delete {n} message(s)? This cannot be undone.',
  'Supprimer la règle {name}': 'Delete rule {name}',
  'Supprimer la sélection': 'Delete selection',
  'Supprimer le brouillon': 'Delete draft',
  'Supprimer le dossier': 'Delete folder',
  'Supprimer {name}': 'Delete {name}',
  'Sécurité et sessions': 'Security and sessions',
  'Sélectionner tous les messages affichés': 'Select all displayed messages',
  'Sélectionner {subject}': 'Select {subject}',
  'Sélectionnez le texte pour le copier.': 'Select the text to copy it.',
  'Sélectionnez les codes pour les copier manuellement.': 'Select the codes to copy them manually.',
  'Sélectionnez un message pour commencer.': 'Select a message to get started.',
  'Terminez la saisie du destinataire pour enregistrer le brouillon.':
    'Finish typing the recipient to save the draft.',
  'Terminez le message ouvert avant de modifier ce brouillon.':
    'Finish the open message before editing this draft.',
  'Texte copié': 'Text copied',
  Titre: 'Title',
  'Tous les messages': 'All messages',
  'Tout est à jour dans votre réception.': 'Your inbox is up to date.',
  'Tout est à jour.': 'All caught up.',
  'Tout est à sa place.': 'Everything is in its place.',
  'Toute la journée': 'All day',
  'Toutes les conditions': 'All conditions',
  Transférer: 'Forward',
  Télécharger: 'Download',
  'Télécharger le calendrier ICS': 'Download the ICS calendar',
  'Télécharger l’original (.eml)': 'Download the original (.eml)',
  Téléphone: 'Phone',
  'Un accès bien protégé': 'A well-protected access',
  'Un coup de main ?': 'Need a hand?',
  'Un espace clair pour échanger, avancer ensemble':
    'A clear space to exchange, move forward together',
  'Un espace pour vos échanges professionnels.': 'A space for your professional exchanges.',
  'Un message est déjà ouvert. Vous pouvez le fermer en conservant son brouillon.':
    'A message is already open. You can close it and keep its draft.',
  'Un nouveau message ?': 'A new message?',
  'Un peu de clarté dans votre journée.': 'A little clarity in your day.',
  'Une fois': 'Once',
  'Une messagerie pensée pour vous.': 'Email designed for you.',
  'Une remise est différée.': 'A delivery is deferred.',
  'Une seule fois · rappel 15 minutes avant': 'Once · reminder 15 minutes before',
  'VOTRE TRAVAIL. VOS ÉCHANGES.': 'YOUR WORK. YOUR CONVERSATIONS.',
  'Valeur de la condition {n}': 'Value of condition {n}',
  'Vename Mail vous aide à recevoir, rédiger et retrouver vos messages.':
    'Vename Mail helps you receive, write and find your messages.',
  'Version pilote': 'Pilot version',
  'Volet Agenda': 'Calendar panel',
  'Vos notifications': 'Your notifications',
  'Vos préférences sont enregistrées.': 'Your preferences are saved.',
  'Vos rendez-vous et invitations, dans votre fuseau horaire.':
    'Your appointments and invitations, in your time zone.',
  'Vos sessions ouvertes': 'Your open sessions',
  'Vos échanges, dans votre espace.': 'Your conversations, in your space.',
  'Votre accès est protégé par une double authentification.':
    'Your access is protected by two-factor authentication.',
  'Votre compte est protégé.': 'Your account is protected.',
  'Votre envoi est pris en charge.': 'Your send has been accepted.',
  'Votre espace, protégé.': 'Your space, protected.',
  'Votre espace, vos préférences.': 'Your space, your preferences.',
  'Votre invitation Vename Mail': 'Your Vename Mail invitation',
  'Votre message attend sa prise en charge.': 'Your message is waiting to be processed.',
  'Votre messagerie, simplement.': 'Your email, simply.',
  'Votre message…': 'Your message…',
  'Vous pouvez fermer l’accès d’un appareil que vous ne reconnaissez pas.':
    'You can close the access of a device you do not recognise.',
  'Vous pouvez inviter 50 personnes au maximum.': 'You can invite up to 50 people.',
  Vue: 'View',
  'Vérification…': 'Verifying…',
  'Vérifier la prise en charge': 'Check acceptance',
  'Vérifier mon code': 'Verify my code',
  'Vérifiez la prise en charge ou réessayez le même envoi avant de fermer.':
    'Check acceptance or retry the same send before closing.',
  'Vérifiez le résultat de l’envoi avant de supprimer le brouillon.':
    'Check the send result before deleting the draft.',
  'Vérifiez votre identité.': 'Verify your identity.',
  'a pour domaine': 'has domain',
  'arrêter les règles suivantes': 'stop further rules',
  'ce message': 'this message',
  'classer dans {folder}': 'file into {folder}',
  'commence par': 'starts with',
  'commencent par': 'start with',
  'en attente': 'pending',
  'est exactement': 'is exactly',
  'et garder l’essentiel à portée de main.': 'and keep the essentials within reach.',
  'jusqu’au': 'until',
  'le message': 'the message',
  'limite de 5 000 contacts atteinte': '5,000 contact limit reached',
  'marquer comme lu': 'mark as read',
  'mettre en favori': 'star',
  'prise en charge par la messagerie': 'accepted by the mail service',
  'se termine par': 'ends with',
  'un dossier retiré': 'a removed folder',
  'un message.': 'a message.',
  '{n} adresse(s) secondaire(s) non reprise(s)': '{n} secondary address(es) not imported',
  '{n} déjà dans votre carnet': '{n} already in your address book',
  '{n} en double dans le fichier': '{n} duplicated in the file',
  '{n} ligne(s) sans adresse valide': '{n} line(s) without a valid address',
  '{n} contact importé': '{n} contact imported',
  '{n} contacts importés': '{n} contacts imported',
  '{n} non lu': '{n} unread',
  '{n} non lus': '{n} unread',
  'À VENIR': 'UPCOMING',
  'À l’heure': 'On time',
  'À partir de {time}': 'From {time}',
  'À partir du': 'From',
  'À tous': 'Reply all',
  'Écrire à votre rythme': 'Write at your own pace',
  'Écrire à {email}': 'Write to {email}',
  'État :': 'Status:',
  'Événement enregistré et invitations envoyées.': 'Event saved and invitations sent.',
  'Événement enregistré.': 'Event saved.',
  'Événement unique': 'Single event',
  'Navigation, messagerie, agenda et paramètres.': 'Navigation, mail, calendar and settings.',
  'Ce secret n’est affiché qu’une fois. Utilisez-le dans l’application de messagerie et conservez-le dans votre gestionnaire de mots de passe.':
    'This secret is shown only once. Use it in the mail application and keep it in your password manager.',
  'Ces messages partiront à l’heure choisie. Les droits, le quota et les limites d’envoi sont vérifiés au moment du départ.':
    'These messages will leave at the chosen time. Rights, quota and sending limits are checked at departure.',
  'Cette boîte est hébergée sur un serveur IMAP : la réponse d’absence est transmise au serveur sous forme de script Sieve et envoyée par lui après synchronisation.':
    'This mailbox is hosted on an IMAP server: the out-of-office reply is sent to it as a Sieve script and delivered by that server once synchronised.',
  'Cette boîte est hébergée sur un serveur IMAP : vos règles sont transmises au serveur sous forme de script Sieve à chaque enregistrement et appliquées à la remise après synchronisation.':
    'This mailbox is hosted on an IMAP server: your rules are sent to it as a Sieve script each time you save and applied on delivery once synchronised.',
  'Collez du texte ou du code HTML. La signature est ajoutée aux nouveaux messages et réponses.':
    'Paste text or HTML. The signature is added to new messages and replies.',
  'Dans un nouveau message, choisissez « Programmer l’envoi » pour différer son départ.':
    'In a new message, choose “Schedule send” to delay its departure.',
  'Enregistrer envoie une invitation calendrier aux invités. Modifier une série demande une nouvelle confirmation. Les rappels apparaissent lorsque l’agenda est ouvert.':
    'Saving sends a calendar invitation to the guests. Editing a series asks for a new confirmation. Reminders appear while the calendar is open.',
  'Ils vous permettront de vous connecter si vous perdez votre téléphone. Chaque code est utilisable une seule fois.':
    'They let you sign in if you lose your phone. Each code can be used once.',
  'Seule une invitation encore en attente peut être annulée. Suspendez plutôt le compte.':
    'Only a pending invitation can be cancelled. Suspend the account instead.',
  'Cette boîte a déjà servi (messages, alias, listes ou délégations) : suspendez plutôt le compte.':
    'This mailbox has already been used (messages, aliases, lists or delegations): suspend the account instead.',
  'Cette boîte a déjà reçu des messages : suspendez plutôt le compte.':
    'This mailbox has already received messages: suspend the account instead.',
  'Le serveur de messagerie n’a pas pu retirer la boîte. Réessayez dans un instant.':
    'The mail server could not remove the mailbox. Try again in a moment.',
  'Annuler l’invitation': 'Cancel the invitation',
  'Annuler l’invitation de {name} ? Sa boîte, encore vide, sera supprimée et son adresse libérée. Le lien déjà envoyé ne fonctionnera plus.':
    'Cancel the invitation of {name}? Their mailbox, still empty, will be deleted and its address freed. The link already sent will no longer work.',
  'Invitation annulée.': 'Invitation cancelled.',
  'Invitation annulée': 'Invitation cancelled',
  'Confirmez votre identité : reconnectez-vous pour poursuivre.':
    'Confirm your identity: sign in again to continue.',
  'Pour cette action, confirmez votre identité en vous reconnectant. Avec la double authentification, vous n’aurez plus à le faire.':
    'For this action, confirm your identity by signing in again. With two-factor authentication, you will no longer need to.',
  'Me reconnecter': 'Sign in again',
  'Protégez votre compte avec la double authentification.':
    'Protect your account with two-factor authentication.',
  Activer: 'Turn on',
  'Plus tard': 'Later',
  'Renforcez la protection de votre compte.': 'Strengthen the protection of your account.',
  'Avec la double authentification, un code de votre application d’authentification est demandé en plus du mot de passe à chaque connexion.':
    'With two-factor authentication, a code from your authenticator app is asked for in addition to your password at each sign-in.',
  'Activer la double authentification': 'Turn on two-factor authentication',
  'Nouveaux codes de secours': 'New recovery codes',
  'Toujours exigée pour les administrateurs. Facultative pour les autres membres, sauf si vous l’exigez pour tous : ceux qui ne l’ont pas la configureront à leur prochaine connexion.':
    'Always required for administrators. Optional for other members, unless you require it for everyone: those without it will set it up at their next sign-in.',
  'Exiger pour tous les membres': 'Require for all members',
  'Double authentification exigée pour tous les membres.':
    'Two-factor authentication required for all members.',
  'Double authentification facultative pour les utilisateurs.':
    'Two-factor authentication optional for users.',
  Facultative: 'Optional',
  'La connexion a expiré avant d’aboutir. Relancez-la.':
    'Sign-in expired before it finished. Please start it again.',
  'La double authentification doit être confirmée. Si vous venez de configurer votre application d’authentification, relancez la connexion et saisissez son code.':
    'Two-factor authentication must be confirmed. If you have just set up your authenticator app, sign in again and enter its code.',
  'La mise en forme est conservée. Les images distantes et contenus actifs sont bloqués.':
    'Formatting is kept. Remote images and active content are blocked.',
  'Le brouillon est enregistré après une courte pause. En cas de coupure, gardez l’onglet ouvert ou copiez votre texte.':
    'The draft is saved after a short pause. If the connection drops, keep the tab open or copy your text.',
  'Le résultat est incertain. Ne renvoyez pas le message avant vérification.':
    'The result is uncertain. Do not resend the message before checking.',
  'Les images distantes sont bloquées. Vous pouvez télécharger vos messages au format .eml depuis le menu de lecture.':
    'Remote images are blocked. You can download your messages as .eml from the reading menu.',
  'Les listes sont chargées par pages de 50 messages. La recherche reste limitée à votre boîte.':
    'Lists load in pages of 50 messages. Search stays within your mailbox.',
  'Les messages de ce dossier sont purgés après 30 jours. Restaurez ceux que vous souhaitez conserver.':
    'Messages in this folder are purged after 30 days. Restore the ones you want to keep.',
  'Les règles s’appliquent aux messages reçus, dans l’ordre affiché, avant leur arrivée dans votre boîte. Elles ne transfèrent ni ne suppriment définitivement un message.':
    'Rules apply to incoming messages, in the order shown, before they reach your mailbox. They never forward or permanently delete a message.',
  'Pendant votre absence, chaque correspondant qui vous écrit directement reçoit une seule réponse automatique par semaine. Les listes de diffusion, les messages automatiques et les indésirables ne reçoivent jamais de réponse.':
    'While you are away, each correspondent who writes to you directly receives one automatic reply per week. Mailing lists, automatic messages and junk never get a reply.',
  'Pour tester les échanges, utilisez alice@kora.test, malik@kora.test ou awa@naya.test. Aucun email ne quitte l’environnement local.':
    'To test exchanges, use alice@kora.test, malik@kora.test or awa@naya.test. No email leaves the local environment.',
  'Recherchez un mot de l’objet, le texte du message ou un expéditeur. Le raccourci Ctrl / ⌘ K ouvre la recherche.':
    'Search a word of the subject, the message text or a sender. The Ctrl / ⌘ K shortcut opens the search.',
  'Saisissez le code de votre application d’authentification ou un code de secours.':
    'Enter the code from your authenticator app or a recovery code.',
  'Scannez ce QR code avec votre application d’authentification, puis saisissez le code à six chiffres.':
    'Scan this QR code with your authenticator app, then enter the six-digit code.',
  'Si votre téléphone est indisponible, choisissez une autre méthode et utilisez un code de secours conservé lors de l’activation. Si vous avez également perdu vos codes, contactez votre administrateur pour une vérification d’identité.':
    'If your phone is unavailable, choose another method and use a recovery code kept at activation. If you have also lost your codes, contact your administrator for an identity check.',
  'Sur l’écran de connexion sécurisée, choisissez « Mot de passe oublié » pour recevoir un lien sur votre adresse de récupération extérieure à Vename Mail. Votre second facteur restera requis.':
    'On the secure sign-in screen, choose “Forgotten password” to receive a link at your recovery address outside Vename Mail. Your second factor will still be required.',
  'Un accès distinct pour chaque application, révocable à tout moment. Choisissez sa durée et ses droits.':
    'A separate access for each application, revocable at any time. Choose its duration and rights.',
  'Votre boîte utilise plus de 80 % de son quota. Libérez de l’espace avant d’atteindre la limite.':
    'Your mailbox uses more than 80% of its quota. Free up space before reaching the limit.',
  'Votre carnet est vide. Les contacts que vous ajoutez restent privés et vous sont proposés lors de la rédaction.':
    'Your address book is empty. Contacts you add stay private and are suggested while you write.',
  'Votre carnet, les adresses actives de votre domaine et vos correspondants. Entrée pour ajouter.':
    'Your address book, the active addresses of your domain and your correspondents. Enter to add.',
  Brouillons: 'Drafts',
  Archives: 'Archive',
  Indésirables: 'Junk',
  Corbeille: 'Bin',
  Favoris: 'Starred',
  Envoyés: 'Sent',
  Messages: 'Messages',
  Connecté: 'Online',
  'Non lus': 'Unread',
  'Bonjour {name}.': 'Hello {name}.',
  'Vous avez {n} messages à découvrir.': 'You have {n} messages to discover.',
  'Vous avez {n} message à découvrir.': 'You have {n} message to discover.',
  Développer: 'Expand',
  Réduire: 'Minimise',
  Brouillon: 'Draft',
  Copiés: 'Copied',
  Copier: 'Copy',
  Révoqué: 'Revoked',
  'Expire le {date}': 'Expires on {date}',
  Annulé: 'Cancelled',
  Organisateur: 'Organiser',
  Invitation: 'Invitation',
  Refusé: 'Declined',
  Provisoire: 'Tentative',
  Destinataire: 'Recipient',
  Contenu: 'Body',
  Active: 'Active',
  Inactive: 'Inactive',
  Ko: 'KB',
  Mo: 'MB',
  Go: 'GB',
  octets: 'bytes',
  Accepté: 'Accepted',
  Période: 'Period',
  '7 derniers jours': 'Last 7 days',
  '30 derniers jours': 'Last 30 days',
  'Dates précises': 'Specific dates',
  Du: 'From',
  Au: 'To',
  'Type d’action': 'Action type',
  Recherche: 'Search',
  'Acteur, cible ou détail': 'Actor, target or detail',
  '{n} événements sur la période': '{n} events in the period',
  '{n} événement sur la période': '{n} event in the period',
  'Consultation limitée aux {n} derniers jours': 'Consultation limited to the last {n} days',
  'Exporter (CSV)': 'Export (CSV)',
  'Chargement du journal…': 'Loading the log…',
  'Aucun événement sur cette période': 'No event in this period',
  'Élargissez la période ou retirez un filtre.': 'Widen the period or remove a filter.',
  'Charger la suite': 'Load more',
  'Toutes les actions': 'All actions',
  'Sécurité et connexions': 'Security and sign-ins',
  Collaborateurs: 'Team members',
  Domaines: 'Domains',
  Alias: 'Aliases',
  Listes: 'Lists',
  Envois: 'Sends',
  'Réponse d’absence': 'Out-of-office reply',
  Organisation: 'Organisation',
  Journal: 'Log',
  'Domaine ajouté': 'Domain added',
  'Vérification DNS': 'DNS check',
  'Collaborateur invité': 'Team member invited',
  'Accès collaborateur modifié': 'Team member access changed',
  'Connexion sécurisée': 'Secure sign-in',
  'Double authentification activée': 'Two-factor authentication enabled',
  'Code de secours utilisé': 'Recovery code used',
  Déconnexion: 'Sign-out',
  'Session révoquée': 'Session revoked',
  'Alias créé': 'Alias created',
  'Alias supprimé': 'Alias deleted',
  'Liste créée': 'List created',
  'Liste modifiée': 'List updated',
  'Liste supprimée': 'List deleted',
  'Envoi pris en charge': 'Send accepted',
  'Envoi traité': 'Send processed',
  'Envoi programmé': 'Send scheduled',
  'Envoi programmé libéré': 'Scheduled send released',
  'Envoi programmé annulé': 'Scheduled send cancelled',
  'Envoi programmé en échec': 'Scheduled send failed',
  'Règle de tri créée': 'Sorting rule created',
  'Règle de tri modifiée': 'Sorting rule updated',
  'Règle de tri supprimée': 'Sorting rule deleted',
  'Règles de tri réordonnées': 'Sorting rules reordered',
  'Réponse d’absence modifiée': 'Out-of-office reply updated',
  'Réponse d’absence envoyée': 'Out-of-office reply sent',
  'Message exporté': 'Message exported',
  'Messages supprimés définitivement': 'Messages permanently deleted',
  'Contact ajouté': 'Contact added',
  'Contact modifié': 'Contact updated',
  'Contact supprimé': 'Contact deleted',
  'Carnet importé': 'Address book imported',
  'Configuration exportée': 'Configuration exported',
  'Profil modifié': 'Profile updated',
  'Journal d’activité exporté': 'Activity log exported',
  'Mes données': 'My data',
  'Téléchargez une archive de vos données dans des formats standards : vos dossiers en mbox, votre carnet en vCard et votre agenda en iCalendar, avec un manifeste et l’empreinte de chaque fichier.':
    'Download an archive of your data in standard formats: your folders as mbox, your address book as vCard and your calendar as iCalendar, with a manifest and the checksum of each file.',
  'Préparation du récapitulatif…': 'Preparing the summary…',
  'L’export complet n’est pas disponible pour cette boîte pour le moment.':
    'The full export is not available for this mailbox at the moment.',
  Dossiers: 'Folders',
  Contacts: 'Contacts',
  Événements: 'Events',
  'Taille approximative': 'Approximate size',
  'Télécharger l’archive (.zip)': 'Download the archive (.zip)',
  'L’export reste possible après une suspension commerciale, jusqu’à la suppression des données. Chaque export est inscrit au journal d’activité.':
    'Export remains possible after a commercial suspension, until the data is deleted. Each export is recorded in the activity log.',
  'Export complet de la boîte': 'Full mailbox export',
  'Sections du carnet': 'Address book sections',
  Fréquents: 'Frequent',
  'Autres contacts': 'Other contacts',
  Doublons: 'Duplicates',
  '{n} groupes de doublons trouvés : {names}': '{n} duplicate groups found: {names}',
  '{n} groupe de doublons trouvé : {names}': '{n} duplicate group found: {names}',
  Ignorer: 'Dismiss',
  Afficher: 'Show',
  '{n} sélectionnés': '{n} selected',
  '{n} sélectionné': '{n} selected',
  Écrire: 'Write',
  'Annuler la sélection': 'Clear selection',
  'Aucun correspondant fréquent pour le moment.': 'No frequent correspondent yet.',
  'Toutes les personnes qui vous ont écrit figurent déjà dans votre carnet.':
    'Everyone who wrote to you is already in your address book.',
  'Aucun doublon détecté.': 'No duplicate detected.',
  'Choisissez la fiche à conserver ; les champs vides sont complétés depuis les autres, qui sont ensuite supprimées.':
    'Choose the record to keep; empty fields are completed from the others, which are then deleted.',
  'aucun autre détail': 'no other detail',
  Fusionner: 'Merge',
  'Sélectionner tous les contacts affichés': 'Select all displayed contacts',
  'E-mail': 'Email',
  'Favoris ({n})': 'Starred ({n})',
  'Tous les contacts ({n})': 'All contacts ({n})',
  '{n} contact(s) seront retirés de votre carnet. Cette action est irréversible.':
    '{n} contact(s) will be removed from your address book. This cannot be undone.',
  'Chargement des correspondants…': 'Loading correspondents…',
  'Dernier message': 'Last message',
  'Messages reçus': 'Messages received',
  'Ajouter {email} au carnet': 'Add {email} to the address book',
  'Retirer des favoris': 'Remove from starred',
  '{n} contacts supprimés.': '{n} contacts deleted.',
  '{n} contact supprimé.': '{n} contact deleted.',
  'Doublons fusionnés.': 'Duplicates merged.',
  Libellés: 'Labels',
  Tous: 'All',
  'Gérer les libellés': 'Manage labels',
  'Écrire au libellé': 'Write to the label',
  'Filtrer par ce libellé': 'Filter by this label',
  Libellé: 'Label',
  'Aucun libellé. Créez-en un depuis « Gérer les libellés ».':
    'No label. Create one from “Manage labels”.',
  Appliquer: 'Apply',
  Retirer: 'Remove',
  'Libellé « {name} » appliqué.': 'Label “{name}” applied.',
  'Libellé « {name} » retiré.': 'Label “{name}” removed.',
  'Libellé créé.': 'Label created.',
  'Libellé supprimé.': 'Label deleted.',
  'Contact restauré.': 'Contact restored.',
  'Contact supprimé définitivement.': 'Contact permanently deleted.',
  'Corbeille vidée : {n} contact(s) supprimé(s) définitivement.':
    'Bin emptied: {n} contact(s) permanently deleted.',
  'Chargement de la corbeille…': 'Loading the bin…',
  'La corbeille est vide. Les contacts supprimés y restent trente jours.':
    'The bin is empty. Deleted contacts stay there for thirty days.',
  'Les contacts supprimés sont conservés trente jours puis retirés définitivement.':
    'Deleted contacts are kept thirty days, then removed for good.',
  'Vider la corbeille': 'Empty the bin',
  'Supprimé le': 'Deleted on',
  'Restaurer {name}': 'Restore {name}',
  'Supprimer définitivement {name}': 'Permanently delete {name}',
  'Nom du libellé': 'Label name',
  'Clients, Fournisseurs, Équipe…': 'Customers, Suppliers, Team…',
  Créer: 'Create',
  'Aucun libellé pour le moment.': 'No label yet.',
  'Supprimer le libellé {name}': 'Delete label {name}',
  'Supprimer un libellé ne supprime aucun contact.': 'Deleting a label deletes no contact.',
  'Les contacts de la corbeille seront supprimés définitivement.':
    'Contacts in the bin will be permanently deleted.',
  'Contact déplacé dans la corbeille.': 'Contact moved to the bin.',
  '{n} contact(s) seront déplacés dans la corbeille, où ils restent trente jours.':
    '{n} contact(s) will be moved to the bin, where they stay thirty days.',
  Français: 'French',
  Anglais: 'English',
  Langue: 'Language',

  'Connexion interrompue. Votre texte reste dans cet onglet.':
    'Connection interrupted. Your text stays in this tab.',
  // Messages renvoyés par le serveur : le texte français fait office de clé, comme pour
  // l'interface. `src/api.ts` les traduit au moment où la réponse d'erreur est lue.
  'Accès introuvable.': 'Access not found.',
  'Accès nominatif OAuth requis.': 'Named OAuth access is required.',
  'Accès opérateur requis.': 'Operator access is required.',
  'Accès réservé à l’administration de cette organisation.':
    'Restricted to the administrators of this organisation.',
  'Accès à la boîte indisponible.': 'Mailbox access unavailable.',
  'Accès à la facturation refusé.': 'Billing access denied.',
  'Activez le fournisseur IAM et les invitations.': 'Enable the identity provider and invitations.',
  'Administration de votre organisation requise.':
    'Administration of your organisation is required.',
  'Adresse déjà utilisée.': 'That address is already in use.',
  'Ajoutez au moins une action de classement ou de marquage.':
    'Add at least one filing or marking action.',
  'Alias introuvable.': 'Alias not found.',
  'Aucun ajustement à facturer.': 'No adjustment to invoice.',
  'Aucun complément anticipé à préparer pour cette période.':
    'No prepaid add-on to prepare for this period.',
  'Aucun envoi programmé à annuler.': 'No scheduled message to cancel.',
  'Aucune boîte nominative utilisable : activation commerciale différée.':
    'No usable named mailbox: commercial activation is deferred.',
  'Aucune prise en charge trouvée pour cette demande. Vous pouvez réessayer avec la même clé.':
    'No record was found for this request. You can retry with the same key.',
  'Aucune unité disponible. Souscrivez une unité avant la conversion.':
    'No unit available. Subscribe to a unit before converting.',
  'Aucune unité souscrite disponible.': 'No subscribed unit is available.',
  'Boîte d’envoi incohérente. Réessayez.': 'Inconsistent outbox. Try again.',
  'Boîte introuvable.': 'Mailbox not found.',
  'Boîte partagée introuvable.': 'Shared mailbox not found.',
  'Brouillon introuvable.': 'Draft not found.',
  'Capacité pilote atteinte.': 'Pilot capacity reached.',
  'Ce brouillon a changé dans un autre onglet.': 'This draft changed in another tab.',
  'Ce brouillon a changé. Rechargez sa version avant l’envoi.':
    'This draft changed. Reload its version before sending.',
  'Ce brouillon a été modifié dans un autre onglet. Votre texte est conservé ici.':
    'This draft was edited in another tab. Your text is kept here.',
  'Ce compte ne dispose pas de boîte personnelle.': 'This account has no personal mailbox.',
  'Ce compte ne nécessite pas d’invitation.': 'This account does not need an invitation.',
  'Ce compte ne peut pas gérer de contacts.': 'This account cannot manage contacts.',
  'Ce dossier contient {n} message(s). Confirmez leur déplacement vers la corbeille.':
    'This folder holds {n} message(s). Confirm moving them to the bin.',
  'Ce message nécessite un rapprochement manuel avant déplacement.':
    'This message needs a manual reconciliation before it can be moved.',
  'Ce message n’appartient pas à la cellule IMAP.':
    'This message does not belong to the IMAP cell.',
  'Ce nom est réservé aux boîtes partagées.': 'That name is reserved for shared mailboxes.',
  'Ce plafond dépasse le stockage non attribué de l’organisation.':
    "That cap exceeds the organisation's unallocated storage.",
  'Cet accès a été suspendu.': 'This access has been suspended.',
  'Cette action est réservée aux opérateurs Vename.':
    'This action is reserved for Vename operators.',
  'Cette action nécessite un propriétaire.': 'This action requires an owner.',
  'Cette action nécessite un rôle d’administration.': 'This action requires an administrator role.',
  'Cette adresse de récupération est indisponible. Utilisez une adresse personnelle distincte.':
    'That recovery address is unavailable. Use a separate personal address.',
  'Cette adresse d’expédition ne vous est pas autorisée.':
    'You are not allowed to send from that address.',
  'Cette adresse est indisponible.': 'That address is unavailable.',
  'Cette adresse figure déjà dans votre carnet.': 'That address is already in your address book.',
  'Autres adresses': 'Other addresses',
  'Une adresse par ligne, dix au maximum.': 'One address per line, ten at most.',
  'L’adresse {email} appartient déjà à un autre contact de votre carnet.':
    'The address {email} already belongs to another contact in your address book.',
  'La fusion donnerait plus de {max} adresses secondaires à un même contact.':
    'Merging would give one contact more than {max} secondary addresses.',
  'Cette boîte ne vous est pas accessible.': 'This mailbox is not accessible to you.',
  'Cette clé d’envoi a déjà été utilisée pour un autre message.':
    'That send key has already been used for another message.',
  'Cette commande existe déjà.': 'This command already exists.',
  'Cette identité a changé. Reconnectez-vous.': 'This identity changed. Sign in again.',
  'Cette identité ne possède pas d’accès Vename Mail actif.':
    'This identity has no active Vename Mail access.',
  'Cette invitation est expirée ou a déjà été utilisée.':
    'This invitation has expired or has already been used.',
  'Cette liste ne compte aucun membre actif.': 'This list has no active member.',
  'Cette modification nécessite un propriétaire.': 'This change requires an owner.',
  'Cette offre n’est pas ouverte à la souscription.': 'This plan is not open for subscription.',
  'Cette opération possède déjà un contenu différent.':
    'This operation already has different content.',
  'Cette pièce jointe est bloquée ou en attente d’analyse.':
    'This attachment is blocked or awaiting scanning.',
  'Cette pièce jointe est en attente d’analyse ou bloquée.':
    'This attachment is awaiting scanning or blocked.',
  'Cette période d’absence est déjà terminée : choisissez une nouvelle fin.':
    'This out-of-office period has already ended: choose a new end date.',
  'Cette ressource est indisponible ou existe déjà.':
    'This resource is unavailable or already exists.',
  'Cette version du brouillon a déjà été soumise. Vérifiez son état avant un nouvel envoi.':
    'This version of the draft has already been submitted. Check its status before sending again.',
  'Chaque délégué doit posséder une boîte nominative active dans cette organisation.':
    'Every delegate must have an active named mailbox in this organisation.',
  'Chaque membre doit être une boîte active de votre organisation.':
    'Every member must be an active mailbox of your organisation.',
  'Choisissez au moins un doublon à fusionner.': 'Choose at least one duplicate to merge.',
  'Choisissez le dossier de destination.': 'Choose the destination folder.',
  'Choisissez résiliation ou changement.': 'Choose either termination or a change.',
  'Choisissez une période de 93 jours au maximum.': 'Choose a period of at most 93 days.',
  'Choisissez une réponse.': 'Choose a response.',
  'Clé déjà utilisée avec une autre commande.': 'Key already used with another command.',
  'Clé déjà utilisée pour une autre commande.': 'Key already used for another command.',
  'Clé déjà utilisée.': 'Key already used.',
  'Clé d’idempotence obligatoire.': 'An idempotency key is required.',
  'Code incorrect, expiré ou déjà utilisé.': 'Incorrect, expired or already used code.',
  'Colonne d’adresse email introuvable. En-têtes lus : {headers}.':
    'No email address column found. Headers read: {headers}.',
  'Compte absent, terminé ou modifié.': 'Account missing, completed or changed.',
  'Compte absent.': 'Account missing.',
  'Compte indisponible.': 'Account unavailable.',
  'Compte introuvable.': 'Account not found.',
  'Configurez d’abord votre application d’authentification.':
    'Set up your authentication app first.',
  'Confirmez la suppression des messages en corbeille.':
    'Confirm the deletion of the messages in the bin.',
  'Confirmez la suppression définitive.': 'Confirm the permanent deletion.',
  'Confirmez le déplacement de {n} message(s) vers la corbeille.':
    'Confirm moving {n} message(s) to the bin.',
  'Conflit de réservation d’envoi.': 'Send reservation conflict.',
  'Conflit d’événement.': 'Event conflict.',
  'Connectez-vous pour continuer.': 'Sign in to continue.',
  'Connexion expirée ou déjà utilisée.': 'Sign-in expired or already used.',
  'Connexion expirée.': 'Sign-in expired.',
  'Conservez le tarif garanti de la période.': 'Keep the guaranteed price for the period.',
  'Contact introuvable dans la corbeille.': 'Contact not found in the bin.',
  'Contact introuvable.': 'Contact not found.',
  'Curseur invalide.': 'Invalid cursor.',
  'Date ou fuseau invalide, ou heure ambiguë lors du changement d’heure.':
    'Invalid date or time zone, or an ambiguous time at a daylight saving change.',
  'Demande indisponible ou expirée.': 'Request unavailable or expired.',
  'Domaine introuvable.': 'Domain not found.',
  'Domaine opérateur vérifié requis.': 'A verified operator domain is required.',
  'Domaine ou boîte introuvable.': 'Domain or mailbox not found.',
  'Domaine vérifié requis.': 'A verified domain is required.',
  'Dossier de destination invalide.': 'Invalid destination folder.',
  'Dossier indisponible.': 'Folder unavailable.',
  'Dossier introuvable.': 'Folder not found.',
  'Dossier invalide.': 'Invalid folder.',
  'Dossier personnel introuvable.': 'Personal folder not found.',
  'Délégation absente, révoquée ou droit insuffisant.':
    'Delegation missing, revoked or insufficient right.',
  'Délégué en double.': 'Duplicate delegate.',
  'En mode privé, les destinataires doivent être des boîtes, alias ou listes créés dans Vename Mail.':
    'In local mode, recipients must be mailboxes, aliases or lists created in Vename Mail.',
  'Envoi introuvable.': 'Message not found.',
  'Espace insuffisant pour la copie dans les messages envoyés.':
    'Not enough space for the copy in sent messages.',
  'Export indisponible : les données de l’organisation sont en attente de suppression.':
    "Export unavailable: the organisation's data is awaiting deletion.",
  'Extension non ouverte dans cette édition du catalogue.':
    'Add-on not open in this edition of the catalogue.',
  'Facture introuvable.': 'Invoice not found.',
  'Fichier manquant.': 'File missing.',
  'Format non reconnu : fournissez un fichier vCard (.vcf) ou CSV avec en-têtes.':
    'Unrecognised format: provide a vCard (.vcf) or a CSV file with headers.',
  'Fuseau horaire inconnu.': 'Unknown time zone.',
  'Gérez votre MFA auprès du fournisseur d’identité.':
    'Manage your two-factor authentication with the identity provider.',
  'Identifiants incorrects ou accès indisponible.': 'Incorrect credentials or access unavailable.',
  'Identité et contact indépendant requis.':
    'An identity and an independent contact address are required.',
  'Impossible de terminer cette action.': 'This action could not be completed.',
  'Indiquez une adresse de récupération indépendante de la nouvelle boîte.':
    'Give a recovery address independent of the new mailbox.',
  'Intégrité du message invalide.': 'Invalid message integrity.',
  'Invitation expirée ou indisponible.': 'Invitation expired or unavailable.',
  'Invitation obsolète ou annulée.': 'Invitation outdated or cancelled.',
  'Invitation remplacée ou annulée. Utilisez la dernière invitation reçue.':
    'Invitation replaced or cancelled. Use the most recent invitation you received.',
  'La boîte a changé.': 'The mailbox changed.',
  'La boîte a changé. Rechargez la liste.': 'The mailbox changed. Reload the list.',
  'La boîte doit être provisionnée dans la cellule mail de recette.':
    'The mailbox must be provisioned in the test mail cell.',
  'La boîte dépasse 4 Gio : l’export en une seule archive n’est pas possible. Contactez votre administrateur.':
    'The mailbox is larger than 4 GiB: a single-archive export is not possible. Contact your administrator.',
  'La boîte est déjà de ce type.': 'The mailbox is already of that kind.',
  'La configuration de cette boîte est en cours. Réessayez dans un instant.':
    'This mailbox is still being configured. Try again in a moment.',
  'La configuration de cette boîte est indisponible.':
    'The configuration of this mailbox is unavailable.',
  'La connexion sécurisée a échoué. Relancez la connexion.':
    'The secure sign-in failed. Start signing in again.',
  'La facturation est déjà activée.': 'Billing is already enabled.',
  'La fin de la période doit suivre son début.': 'The end of the period must follow its start.',
  'La fin de l’absence doit suivre son début.':
    'The end of the out-of-office period must follow its start.',
  'La fin doit suivre le début, dans un délai de 31 jours.':
    'The end must follow the start, within 31 days.',
  'La limite de 100 dossiers personnels est atteinte.':
    'The limit of 100 personal folders has been reached.',
  'La liste doit contenir vos règles, une seule fois chacune.':
    'The list must contain your rules, each of them exactly once.',
  'La politique a été modifiée. Rechargez sa version.':
    'The policy was changed. Reload its version.',
  'La politique autorise au maximum {max} destinataires par message.':
    'The policy allows at most {max} recipients per message.',
  'La preuve de propriété a expiré. Renouvelez le défi DNS.':
    'The proof of ownership expired. Renew the DNS challenge.',
  'La recette IAM accepte uniquement des adresses fictives en .test.':
    'The identity test environment only accepts fictitious .test addresses.',
  'La réception des réponses est suspendue pour cet organisateur.':
    'Receiving responses is suspended for this organiser.',
  'La taille maximale cumulée des pièces jointes est de 18 Mio.':
    'The total size of attachments is limited to 18 MiB.',
  'La vérification de votre identité est momentanément indisponible.':
    'Verifying your identity is temporarily unavailable.',
  'Le complément doit être facturé et réglé avant activation.':
    'The add-on must be invoiced and paid before activation.',
  'Le connecteur de provisioning IAM doit être configuré.':
    'The identity provisioning connector must be configured.',
  'Le dernier propriétaire actif ne peut pas être suspendu ou rétrogradé.':
    'The last active owner cannot be suspended or demoted.',
  'Le domaine de cette adresse d’expédition doit être vérifié et prêt.':
    'The domain of that sending address must be verified and ready.',
  'Le domaine doit être vérifié et son routage prêt avant l’envoi.':
    'The domain must be verified and its routing ready before sending.',
  'Le fichier CSV ne contient aucune ligne de contact.': 'The CSV file contains no contact row.',
  'Le fournisseur d’identité a retourné une session invalide.':
    'The identity provider returned an invalid session.',
  'Le fournisseur d’identité est indisponible.': 'The identity provider is unavailable.',
  'Le fournisseur d’identité est invalide.': 'The identity provider is invalid.',
  'Le message complet dépasse 25 Mio après encodage.':
    'The complete message exceeds 25 MiB once encoded.',
  'Le message doit être déclaré sain par une nouvelle analyse.':
    'The message must be found clean by a new scan.',
  'Le nombre d’unités est inférieur au nombre de boîtes attribuées.':
    'The number of units is below the number of allocated mailboxes.',
  'Le paiement dépasse le solde de cette facture.':
    'The payment exceeds the balance of this invoice.',
  'Le partage nécessite les accès mail nominatifs OAuth.':
    'Sharing requires named OAuth mail access.',
  'Le plafond est inférieur au volume utilisé et réservé.':
    'The cap is below the used and reserved volume.',
  'Le provisioning d’identité IAM doit être configuré avant de créer un utilisateur live.':
    'Identity provisioning must be configured before creating a live user.',
  'Le quota de votre boîte est atteint.': 'Your mailbox quota is full.',
  'Le renouvellement doit être traité avant cette modification.':
    'The renewal must be processed before this change.',
  'Le service d’accès aux applications mail n’est pas configuré.':
    'The mail application access service is not configured.',
  'Le service est momentanément indisponible.': 'The service is temporarily unavailable.',
  'Le tarif de la période est garanti : conservez le catalogue courant.':
    'The price of the period is guaranteed: keep the current catalogue.',
  'Les dossiers Brouillons et Envoyés ne peuvent pas recevoir de règle.':
    'The Drafts and Sent folders cannot receive a rule.',
  'Les invitations IAM ne sont pas activées dans cet environnement.':
    'Identity invitations are not enabled in this environment.',
  'Les pièces jointes dépassent 18 Mio.': 'The attachments exceed 18 MiB.',
  'Libellé introuvable.': 'Label not found.',
  'Limite de 100 boîtes partagées atteinte.': 'The limit of 100 shared mailboxes has been reached.',
  'Limite de 2 000 événements atteinte.': 'The limit of 2,000 events has been reached.',
  'Limite des boîtes partagées atteinte.': 'The shared mailbox limit has been reached.',
  'Limite d’envoi atteinte : {minute} destinataires externes par minute et {daily} sur 24 heures glissantes. Réessayez plus tard.':
    'Sending limit reached: {minute} external recipients a minute and {daily} over a rolling 24 hours. Try again later.',
  'Liste introuvable.': 'List not found.',
  'L’analyse antivirus est momentanément indisponible. Ajoutez de nouveau la pièce jointe dans un instant.':
    'Virus scanning is temporarily unavailable. Add the attachment again in a moment.',
  'L’analyse antivirus est momentanément indisponible. Réessayez le téléchargement dans un instant.':
    'Virus scanning is temporarily unavailable. Try the download again in a moment.',
  'L’abonnement a changé. Rechargez et prévisualisez à nouveau.':
    'The subscription changed. Reload and preview again.',
  'L’envoi peut être programmé jusqu’à {days} jours à l’avance.':
    'A message can be scheduled up to {days} days ahead.',
  'L’espace disponible dans cette boîte est insuffisant.':
    'There is not enough space left in this mailbox.',
  'L’heure d’envoi programmée doit être dans au moins une minute.':
    'The scheduled send time must be at least one minute from now.',
  'L’intégrité de la pièce jointe n’a pas pu être vérifiée.':
    'The integrity of the attachment could not be verified.',
  'L’invitation doit être acceptée via le fournisseur d’identité.':
    'The invitation must be accepted through the identity provider.',
  'L’utilisateur doit accepter son invitation.': 'The user must accept their invitation.',
  'Maximum dix accès d’application actifs.': 'At most ten active application accesses.',
  'Message en quarantaine introuvable.': 'Quarantined message not found.',
  'Message introuvable.': 'Message not found.',
  'Message MIME invalide.': 'Invalid MIME message.',
  'Nom de domaine invalide.': 'Invalid domain name.',
  'Nom de dossier invalide.': 'Invalid folder name.',
  'Nom de fichier invalide.': 'Invalid file name.',
  'Nom et adresse de récupération du nouveau titulaire requis.':
    "The new holder's name and recovery address are required.",
  'Nom invalide.': 'Invalid name.',
  'Opération introuvable ou déjà terminée.': 'Operation not found or already finished.',
  'Opération introuvable.': 'Operation not found.',
  'Opération suspendue par la facturation ; consultation et export disponibles.':
    'Operation suspended by billing; reading and exporting remain available.',
  'Organisation introuvable.': 'Organisation not found.',
  'Origine de la requête refusée.': 'Request origin refused.',
  'Partie locale invalide : lettres, chiffres, points, tirets et plus uniquement.':
    'Invalid local part: letters, digits, dots, hyphens and plus signs only.',
  'Patientez avant de demander une nouvelle invitation. Maximum cinq demandes par jour.':
    'Wait before asking for another invitation. At most five requests a day.',
  'Pièce jointe introuvable.': 'Attachment not found.',
  'Placez les messages dans la corbeille avant de les supprimer.':
    'Move the messages to the bin before deleting them.',
  'Politique introuvable.': 'Policy not found.',
  'Période de facturation invalide.': 'Invalid billing period.',
  'Retirez préalablement le rôle administratif de ce titulaire.':
    "Remove this holder's administrator role first.",
  'Règle introuvable.': 'Rule not found.',
  'Réattribuez le quota commun avant de créer cette boîte.':
    'Reallocate the shared quota before creating this mailbox.',
  'Réattribuez le stockage disponible avant de créer cette boîte.':
    'Reallocate the available storage before creating this mailbox.',
  'Réduction ou changement de cycle : programmez le changement à échéance dans la facturation.':
    'Reduction or cycle change: schedule the change for the end of the period in billing.',
  'Réduisez et synchronisez les plafonds de boîtes avant de réduire le pool. Aucune donnée ne sera supprimée.':
    'Reduce and synchronise the mailbox caps before shrinking the pool. No data will be deleted.',
  'Référence de paiement déjà enregistrée.': 'Payment reference already recorded.',
  'Référence IMAP indisponible.': 'IMAP reference unavailable.',
  'Régularisez les impayés avant de modifier la souscription.':
    'Settle the outstanding invoices before changing the subscription.',
  'Résultat mail incertain : rapprochement requis avant toute nouvelle écriture.':
    'Uncertain mail outcome: a reconciliation is required before any new write.',
  'Service mail requis.': 'A mail service is required.',
  'Session mail indisponible.': 'Mail session unavailable.',
  'Seul l’organisateur peut annuler.': 'Only the organiser can cancel.',
  'Seul l’organisateur peut modifier cet événement.': 'Only the organiser can change this event.',
  'Seul un complément non réglé et non activé peut être annulé ici.':
    'Only an unpaid and inactive add-on can be cancelled here.',
  'Seul un opérateur peut enregistrer une souscription.':
    'Only an operator can record a subscription.',
  'Seul un propriétaire peut nommer un autre propriétaire.':
    'Only an owner can appoint another owner.',
  'Seuls les dossiers personnels peuvent être modifiés.': 'Only personal folders can be changed.',
  'Synchronisez les boîtes sur le serveur avant l’activation commerciale.':
    'Synchronise the mailboxes on the server before commercial activation.',
  'Synchronisez les plafonds stricts de toutes les boîtes avant d’activer le pool IMAP.':
    'Synchronise the strict caps of every mailbox before enabling the IMAP pool.',
  'Terminez ou rapprochez les envois en cours avant la conversion.':
    'Finish or reconcile the messages in flight before converting.',
  'Trop de fichiers temporaires. Retirez les pièces jointes inutilisées.':
    'Too many temporary files. Remove the attachments you are not using.',
  'Un abonnement actif avec stockage mutualisé est requis.':
    'An active subscription with pooled storage is required.',
  'Un autre opérateur doit préparer votre récupération.':
    'Another operator must prepare your recovery.',
  'Un complément existe déjà pour une autre modification.':
    'An add-on already exists for another change.',
  'Un compte personnel actif est requis pour l’agenda.':
    'An active personal account is required for the calendar.',
  'Un compte sans boîte doit être administrateur.':
    'An account without a mailbox must be an administrator.',
  'Un libellé porte déjà ce nom.': 'A label already has that name.',
  'Un message est introuvable.': 'A message cannot be found.',
  'Un message peut avoir au maximum 100 destinataires.':
    'A message can have at most 100 recipients.',
  'Un opérateur avec double authentification est requis.':
    'An operator with two-factor authentication is required.',
  'Un second facteur est déjà configuré.': 'A second factor is already set up.',
  'Un second opérateur distinct doit approuver.': 'A second, different operator must approve.',
  'Une clé d’idempotence est obligatoire.': 'An idempotency key is required.',
  'Une copie du message existe déjà dans ce dossier.':
    'A copy of the message already exists in that folder.',
  'Une erreur est survenue. Réessayez dans un instant.':
    'Something went wrong. Try again in a moment.',
  'Une nouvelle authentification après réinitialisation du titulaire est requise.':
    'A new sign-in is required after the holder was reset.',
  'Une pièce jointe a expiré ou ne vous appartient pas.':
    'An attachment has expired or does not belong to you.',
  'Une pièce jointe est bloquée ou en attente d’analyse.':
    'An attachment is blocked or awaiting scanning.',
  'Une règle ne peut désigner qu’un seul dossier de destination.':
    'A rule can name only one destination folder.',
  'Une règle porte déjà ce nom.': 'A rule already has that name.',
  'Une réduction doit être programmée à échéance.':
    'A reduction must be scheduled for the end of the period.',
  'Une session à deux facteurs est requise.': 'A two-factor session is required.',
  'Une écriture de ce message doit être rapprochée.': 'A write of this message must be reconciled.',
  'Une écriture mail doit être rapprochée avant la conversion.':
    'A mail write must be reconciled before converting.',
  'Utilisateur introuvable.': 'User not found.',
  'Utilisez la connexion sécurisée de votre organisation.':
    "Use your organisation's secure sign-in.",
  'Utilisez la gestion des boîtes partagées.': 'Use the shared mailbox management screen.',
  'Utilisez une adresse de récupération personnelle extérieure aux domaines hébergés par Vename Mail.':
    'Use a personal recovery address outside the domains hosted by Vename Mail.',
  'Version de brouillon incompatible avec le rapprochement.':
    'Draft version incompatible with the reconciliation.',
  'Version obsolète.': 'Outdated version.',
  'Votre carnet atteint la limite de {max} contacts.':
    'Your address book has reached the limit of {max} contacts.',
  'Votre organisation atteint la limite de {max} listes.':
    'Your organisation has reached the limit of {max} lists.',
  'Votre session a expiré après une période d’inactivité.':
    'Your session expired after a period of inactivity.',
  'Votre session a expiré. Reconnectez-vous.': 'Your session expired. Sign in again.',
  'Vous n’êtes pas invité.': 'You are not invited.',
  'Vous pouvez créer {max} libellés au maximum.': 'You can create at most {max} labels.',
  'Vous pouvez définir {max} règles au maximum.': 'You can define at most {max} rules.',
  'Vérification de sécurité échouée. Rechargez la page.': 'Security check failed. Reload the page.',
  'Vérifiez d’abord la souscription courante.': 'Check the current subscription first.',
  'Vérifiez les champs du formulaire.': 'Check the fields of the form.',
  'Vérifiez votre second facteur pour continuer.': 'Verify your second factor to continue.',
  'Écriture en cours.': 'A write is in progress.',
  'Émission suspendue : régularisez la facturation de l’organisation.':
    "Sending suspended: settle the organisation's billing.",
  'Événement introuvable.': 'Event not found.',
  'Événement modifié ou annulé. Rechargez-le.': 'Event changed or cancelled. Reload it.',
  'Événement sans soumission acceptée correspondante.':
    'Event with no matching accepted submission.',

  // Écrans d’administration, facturation, souscription, boîtes partagées et console opérateur.
  '(facultative)': '(optional)',
  ', puis abonnez-vous aux dossiers souhaités avec votre compte nominatif.':
    ', then subscribe to the folders you want with your named account.',
  'Abonnement et stockage commun': 'Subscription and shared storage',
  Accepter: 'Accept',
  'Accès aux boîtes d’équipe': 'Access to team mailboxes',
  'Accès aux dossiers dans les logiciels de messagerie :': 'Folder access in mail software:',
  'Accès mis à jour.': 'Access updated.',
  Actif: 'Active',
  Action: 'Action',
  'Activation des comptes': 'Account activation',
  'Activer et émettre la première facture': 'Enable and issue the first invoice',
  'Activer la facturation à partir d’aujourd’hui': 'Enable billing from today',
  Actualiser: 'Refresh',
  'Actualiser les accès IMAP': 'Refresh IMAP access',
  Administrateur: 'Administrator',
  Adresse: 'Address',
  'Adresse de l’alias': 'Alias address',
  'Adresse de récupération indépendante': 'Independent recovery address',
  'Adresse personnelle de récupération indépendante': 'Independent personal recovery address',
  'Adresse professionnelle du collaborateur': "The colleague's work address",
  'Ajouter le domaine': 'Add the domain',
  'Ajouter du stockage': 'Add storage',
  'Ajouter une boîte': 'Add a mailbox',
  'Ajouter un domaine': 'Add a domain',
  'Ajoutez ces valeurs chez votre fournisseur DNS. Pour SPF, adaptez l’enregistrement existant afin de conserver vos autres expéditeurs autorisés.':
    'Add these values at your DNS provider. For SPF, adapt the existing record so your other authorised senders keep working.',
  'Ajoutez votre premier domaine': 'Add your first domain',
  'Alias supprimé.': 'Alias deleted.',
  an: 'year',
  annuel: 'yearly',
  Annuel: 'Yearly',
  Annuelle: 'Yearly',
  'Annuler le changement programmé': 'Cancel the scheduled change',
  'Annuler le complément': 'Cancel the add-on',
  Annulée: 'Cancelled',
  annulée: 'voided',
  'API du webmail': 'Webmail API',
  'Approuver et révoquer les accès': 'Approve and revoke access',
  Approuvée: 'Approved',
  'Attribuer (Go)': 'Allocate (GB)',
  'Aucun alias pour le moment': 'No alias yet',
  'Aucun envoi enregistré pour le moment.': 'No message recorded yet.',
  'Aucune boîte active disponible.': 'No active mailbox available.',
  'Aucune invitation IAM': 'No identity invitation',
  'Aucune liste interne': 'No internal list',
  'Aucune opération de synchronisation': 'No synchronisation job',
  'Aucune unité supplémentaire. Le stockage est prélevé sur le quota commun. Chaque délégué doit posséder une boîte nominative active.':
    'No extra unit. Storage is taken from the shared quota. Every delegate must have an active named mailbox.',
  Boîte: 'Mailbox',
  boîtes: 'mailboxes',
  'Boîtes email': 'Email mailboxes',
  'Boîte de destination': 'Destination mailbox',
  'Boîte mail': 'Mailbox',
  'Choisir la période de facturation': 'Choose the billing period',
  'Choisissez le nombre de boîtes et la période. Chaque boîte ajoute 5 Go au stockage commun de l’organisation.':
    "Choose the number of mailboxes and the billing period. Each mailbox adds 5 GB to the organisation's shared storage.",
  'Combien de boîtes email faut-il ?': 'How many email mailboxes do you need?',
  'Configurer la souscription': 'Configure the subscription',
  'boîte partagée': 'shared mailbox',
  'Boîte partagée créée': 'Shared mailbox created',
  Boîtes: 'Mailboxes',
  'Boîtes partagées': 'Shared mailboxes',
  'Boîtes provisionnées': 'Provisioned mailboxes',
  'Capacité en attente de libération': 'Capacity awaiting release',
  Carte: 'Card',
  'Catalogue {version} · Révision {revision}': 'Catalogue {version} · Revision {revision}',
  'Le plafond d’une boîte ne peut pas être inférieur à 2 Go.':
    'A mailbox ceiling cannot be lower than 2 GB.',
  'Inférieur aux {plan} Go apportés par la formule : les {free} Go libérés restent disponibles pour les autres boîtes.':
    'Below the {plan} GB your plan brings: the {free} GB freed stay available for the other mailboxes.',
  'Organisation pilote': 'Pilot organisation',
  'Aucun abonnement commercial enregistré.': 'No commercial subscription recorded.',
  'HT / mois': 'excl. tax / month',
  'HT / an': 'excl. tax / year',
  'attribuées sur {subscribed} souscrites': 'assigned out of {subscribed} subscribed',
  '{count} disponibles': '{count} available',
  '1 disponible': '1 available',
  'Aucune unité disponible': 'No unit available',
  'sur un pool de {pool}': 'out of a {pool} pool',
  'Pool non activé': 'Pool not activated',
  'Envois réservés : {reserved}': 'Reserved sends: {reserved}',
  'Plafonds attribués': 'Assigned ceilings',
  '{free} disponibles à attribuer': '{free} available to assign',
  '1 Go = 1 milliard d’octets.': '1 GB = 1 billion bytes.',
  'Essai en cours': 'Trial in progress',
  'La facturation de cette organisation est tenue par le site Vename : factures, paiements et relances y sont gérés. Vename Mail en reçoit une copie pour appliquer l’état du service.':
    'This organisation is billed by the Vename website: invoices, payments and reminders are handled there. Vename Mail receives a copy to apply the service status.',
  'Essai gratuit jusqu’au {date}.': 'Free trial until {date}.',
  'L’essai démarrera dès que le domaine sera vérifié.':
    'The trial starts as soon as the domain is verified.',
  'Résiliation effective le {date}.': 'Cancellation effective on {date}.',
  'Aucune facture reçue du site pour l’instant.': 'No invoice received from the website yet.',
  'Total TTC': 'Total incl. tax',
  'Reste dû': 'Amount due',
  Réglée: 'Paid',
  'Paiements reçus du site': 'Payments received from the website',
  'Prix convenu sur le site Vename · Révision {revision}':
    'Price agreed on the Vename website · Revision {revision}',
  'Abonnement tenu par le site Vename : il se modifie par la commande du site.':
    'Subscription managed by the Vename website: change it through the website order.',
  'L’abonnement de cette organisation est tenu par le site Vename.':
    'This organisation’s subscription is managed by the Vename website.',
  'Certificat de messagerie': 'Mail certificate',
  'Cette opération attribue les droits de service. Elle ne débite aucun moyen de paiement et ne produit pas de facture. Pro, Premium et les extensions restent fermés.':
    'This operation grants service rights. It charges no payment method and produces no invoice. Pro, Premium and the add-ons stay closed.',
  'Cette réponse concerne les {n} occurrences de la série.':
    'This response applies to all {n} occurrences in the series.',
  'Changement demandé à échéance': 'Change requested for the end of the period',
  'Changement prévu à l’échéance : {units} unités, formule {plan}, cycle {cadence}.':
    'Change scheduled for the end of the period: {units} units, {plan} plan, {cadence} cycle.',
  'Chaque collaborateur dispose de sa propre boîte.': 'Every colleague has their own mailbox.',
  'Chargement des listes…': 'Loading lists…',
  'Choisir une organisation': 'Choose an organisation',
  Client: 'Customer',
  'Client : raison sociale, adresse, identifiants de facturation':
    'Customer: legal name, address, billing identifiers',
  Collaborateur: 'Colleague',
  'Commande annulée avant paiement et activation': 'Order cancelled before payment and activation',
  'Complément pour la période restante : {amount}.': 'Add-on for the remaining period: {amount}.',
  'Complément réglé.': 'Add-on paid.',
  Compte: 'Account',
  'Compte activé': 'Account activated',
  'Compte en préparation': 'Account being prepared',
  'Configuration des comptes': 'Account configuration',
  'Configuration en cours': 'Being configured',
  'Confirmer la conversion': 'Confirm the conversion',
  'Confirmer l’attribution': 'Confirm the allocation',
  'Connectez le nom de domaine de votre organisation.': "Connect your organisation's domain name.",
  'conservera ses messages et son quota. Les accès actuels et les délégations seront révoqués.':
    'will keep its messages and its quota. Current access and delegations will be revoked.',
  Consulter: 'View',
  'Consultez les unités souscrites et répartissez leur stockage entre vos boîtes.':
    'Review the subscribed units and share their storage across your mailboxes.',
  'Conversion terminée': 'Conversion complete',
  'Convertir en boîte nominative': 'Convert to a named mailbox',
  'Convertir en boîte partagée': 'Convert to a shared mailbox',
  'Copier le lien': 'Copy the link',
  'Créer aussi une boîte mail (une unité)': 'Also create a mailbox (one unit)',
  'Créer la boîte partagée': 'Create the shared mailbox',
  'Créer la liste': 'Create the list',
  'Créer l’alias': 'Create the alias',
  'Créer l’invitation': 'Create the invitation',
  'Créer l’organisation': 'Create the organisation',
  'Créer un alias': 'Create an alias',
  'Créer une organisation': 'Create an organisation',
  'Créez par exemple contact@votre-domaine.': 'Create for instance contact@your-domain.',
  'Créez par exemple equipe@votre-domaine pour écrire à tous vos collaborateurs.':
    'Create for instance team@your-domain to write to all your colleagues.',
  'Demande de {email}': 'Requested by {email}',
  'Dernier export d’audit :': 'Last audit export:',
  Disponible: 'Available',
  'DOCUMENT ANNULÉ — aucun règlement dû.': 'VOIDED DOCUMENT — nothing is due.',
  Domaine: 'Domain',
  'Domaine de test local : ces valeurs ne sont pas publiées sur Internet.':
    'Local test domain: these values are not published on the internet.',
  'Domaine prêt': 'Domain ready',
  'Domaines connectés': 'Connected domains',
  'Double authentification': 'Two-factor authentication',
  'Décocher tous les droits d’une personne révoque son accès. L’administration ne donne aucun accès implicite aux messages.':
    'Clearing every right of a person revokes their access. Administration grants no implicit access to messages.',
  'Délégations mises à jour': 'Delegations updated',
  'Délégations — {address}': 'Delegations — {address}',
  Désignation: 'Description',
  'En attente de vérification DNS': 'Awaiting DNS verification',
  'En cours d’envoi': 'Being sent',
  'En préparation': 'Being prepared',
  'Enregistrer le règlement': 'Record the payment',
  'Enregistrer les délégations': 'Save the delegations',
  'Enregistrer un règlement vérifié': 'Record a verified payment',
  'Enregistrer une souscription confirmée': 'Record a confirmed subscription',
  'Envoi non confirmé': 'Delivery unconfirmed',
  'Envoi refusé': 'Delivery refused',
  'Envois en attente': 'Messages pending',
  'Expiration du lien': 'Link expiry',
  'Exploitation du laboratoire': 'Laboratory operations',
  'Exporter facture et reçus': 'Export invoice and receipts',
  'Exporter la configuration': 'Export the configuration',
  Facturation: 'Billing',
  'Facturation de l’organisation': 'Organisation billing',
  Facture: 'Invoice',
  'Gérer le prochain renouvellement': 'Manage the next renewal',
  'Gérer les délégations': 'Manage delegations',
  'Gérez les accès et la messagerie de {organization}.':
    'Manage access and mail for {organization}.',
  'Historique commercial': 'Commercial history',
  Identité: 'Identity',
  'Identité et connexion': 'Identity and sign-in',
  'Imprimer / enregistrer en PDF': 'Print / save as PDF',
  Incident: 'Incident',
  'Invitation copiée.': 'Invitation copied.',
  'Invitation de l’administrateur': 'Administrator invitation',
  'Invitation en attente · unité réservée': 'Invitation pending · unit reserved',
  'Invitation transmise': 'Invitation sent',
  'Invitation Vename Mail': 'Vename Mail invitation',
  'Inviter un collaborateur': 'Invite a colleague',
  'Inviter un membre': 'Invite a member',
  'Inviter un opérateur': 'Invite an operator',
  Invité: 'Invited',
  'La boîte {address} est créée. Le collaborateur devra choisir son mot de passe et configurer le MFA.':
    'The mailbox {address} is created. The colleague will choose their password and set up two-factor authentication.',
  'La plateforme, en un regard.': 'The platform at a glance.',
  'La première facture couvrira {units} unités, pour un {cadence}. Aucun paiement ne sera déclenché.':
    'The first invoice will cover {units} units, for one {cadence}. No payment will be triggered.',
  'La propriété et le routage sont vérifiés séparément.':
    'Ownership and routing are verified separately.',
  'Le compte {address} est enregistré. Une invitation sera transmise à {contact} après sa préparation. Suivez son envoi dans Invitations. Le lien expire après 72 heures ; le collaborateur choisira son mot de passe et configurera sa double authentification.':
    'The account {address} is recorded. An invitation will be sent to {contact} once prepared. Follow its delivery under Invitations. The link expires after 72 hours; the colleague will choose their password and set up two-factor authentication.',
  'Le domaine attend sa vérification DNS.': 'The domain is awaiting its DNS verification.',
  'Le stockage atteint {percent} % : libérez de l’espace ou demandez une extension. Aucun dépassement payant automatique.':
    'Storage has reached {percent}%: free some space or request an extension. There is no automatic paid overage.',
  'Les actions sensibles restent traçables, sans accès au contenu des messages.':
    'Sensitive actions stay traceable, with no access to message content.',
  'Les dernières actions': 'The latest actions',
  'Les domaines terminant par .test peuvent être activés pour les échanges locaux.':
    'Domains ending in .test can be enabled for local exchanges.',
  'Les fonctions suivent la formule choisie ; Pro reste fermée tant que sa qualification est en cours.':
    'Features follow the chosen plan; Pro stays closed while its qualification is under way.',
  'Les futurs messages envoyés à {address} seront refusés. Les messages déjà distribués restent dans les boîtes des membres.':
    "Future messages sent to {address} will be refused. Messages already delivered stay in the members' mailboxes.",
  'Les invitations sont adressées au contact de récupération personnel. Un envoi non confirmé nécessite une vérification avant de demander un nouveau lien.':
    'Invitations are sent to the personal recovery contact. An unconfirmed delivery needs checking before asking for a new link.',
  'Les membres de votre équipe': 'The members of your team',
  'Les mesures locales sont distinctes de la qualification de production.':
    'Local measurements are separate from production qualification.',
  'Les organisations pilotes ne sont pas facturées automatiquement.':
    'Pilot organisations are not billed automatically.',
  'Les prochaines créations d’organisations apparaîtront ici.':
    'Newly created organisations will appear here.',
  'Les retraits prennent effet à l’échéance, sans remboursement automatique. Les plafonds de stockage et les unités attribuées doivent rester compatibles.':
    'Reductions take effect at the end of the period, with no automatic refund. Storage caps and allocated units must stay compatible.',
  'Lien copié.': 'Link copied.',
  'Lien d’invitation': 'Invitation link',
  'Liste créée.': 'List created.',
  'Liste interne': 'Internal list',
  'Signature DKIM du domaine': 'Domain DKIM signing',
  'Raccordement du domaine à la cellule': 'Domain connection to the mail cell',
  'Ce domaine est déjà raccordé pour une autre organisation. Contactez le support Vename.':
    'This domain is already connected for another organisation. Contact Vename support.',
  'Liste mise à jour.': 'List updated.',
  'Liste supprimée.': 'List deleted.',
  'L’accès direct sera fermé. L’unité reste souscrite et devient réattribuable ; aucun remboursement automatique.':
    'Direct access will be closed. The unit stays subscribed and becomes reassignable; there is no automatic refund.',
  'L’administration permet de gérer les accès et les quotas. Chaque boîte reste accessible à son titulaire.':
    'Administration manages access and quotas. Each mailbox stays accessible to its holder.',
  'L’identité de l’administrateur est en préparation. Son invitation sera envoyée à son contact indépendant. Le lien permettra de choisir son mot de passe et de configurer ses moyens de connexion.':
    "The administrator's identity is being prepared. Their invitation will be sent to their independent contact. The link lets them choose a password and set up their sign-in methods.",
  'L’invitation est prête': 'The invitation is ready',
  'L’invitation sera à transmettre par un canal déjà accessible.':
    'The invitation must be passed on through a channel they can already reach.',
  'Maintenir le renouvellement': 'Keep the renewal',
  Membres: 'Members',
  'Membres ({n}/100)': 'Members ({n}/100)',
  mensuel: 'monthly',
  Mensuel: 'Monthly',
  Mensuelle: 'Monthly',
  'Mobile Money': 'Mobile Money',
  'Modification enregistrée.': 'Change saved.',
  mois: 'month',
  'Montant HT': 'Amount before tax',
  'Montant reçu (FCFA)': 'Amount received (FCFA)',
  Moyen: 'Method',
  'Nom de la boîte': 'Mailbox name',
  'Nom du nouveau titulaire': 'Name of the new holder',
  'Nominative · une unité attribuée': 'Named · one unit allocated',
  'non activé': 'not enabled',
  'non activé sur cet environnement': 'not enabled in this environment',
  'Notifications de facturation': 'Billing notices',
  'Nouvelle invitation planifiée. Suivez son état dans Invitations.':
    'A new invitation is scheduled. Follow its status under Invitations.',
  'Nouvelle liste': 'New list',
  'Nouvelle tentative planifiée.': 'A new attempt is scheduled.',
  Offre: 'Plan',
  'Opérations de provisioning': 'Provisioning jobs',
  'Organisateur : {name}': 'Organiser: {name}',
  'Organisation créée': 'Organisation created',
  'Organisation créée, en attente DNS.': 'Organisation created, awaiting DNS.',
  'Organisation pilote — aucun abonnement commercial enregistré.':
    'Pilot organisation — no commercial subscription recorded.',
  Organisations: 'Organisations',
  'Organisations, opérations et états des envois.':
    'Organisations, operations and delivery status.',
  'par un canal existant. Il expire dans 72 heures et ne peut être utilisé qu’une fois.':
    'through a channel they already use. It expires in 72 hours and can be used only once.',
  'Partagees/adresse@entreprise/': 'Partagees/address@company/',
  'Partagée · sans unité supplémentaire': 'Shared · no extra unit',
  'Partie locale': 'Local part',
  'Pas encore exporté': 'Not exported yet',
  'Peut-être': 'Maybe',
  Pilote: 'Pilot',
  Plafond: 'Cap',
  'Plafond de la boîte en Go': 'Mailbox cap in GB',
  'Plafond enregistré.': 'Cap saved.',
  'Plafonds attribués : {allocated} · Disponible à attribuer : {free}. 1 Go = 1 milliard d’octets.':
    'Allocated caps: {allocated} · Available to allocate: {free}. 1 GB = 1 billion bytes.',
  'Pour consulter dans Thunderbird ou Outlook classique configuré en IMAP, recherchez les dossiers sous':
    'To read them in Thunderbird or classic Outlook set up over IMAP, look for the folders under',
  'prenom@autre-domaine.com': 'name@other-domain.com',
  'Programmer à l’échéance': 'Schedule for the end of the period',
  Propriétaire: 'Owner',
  'Propriété vérifiée': 'Ownership verified',
  'Propriété à vérifier': 'Ownership to verify',
  Protection: 'Protection',
  'Prénom Nom': 'First name Last name',
  'Préparer un changement': 'Prepare a change',
  'Préparer une récupération après perte des facteurs': 'Prepare a recovery after lost factors',
  Prévisualiser: 'Preview',
  'Confirmer cette souscription': 'Confirm this subscription',
  'Confirmer la souscription': 'Confirm the subscription',
  'Période : {start} au {end} (fin exclusive, UTC).':
    'Period: {start} to {end} (end exclusive, UTC).',
  Périodicité: 'Frequency',
  'Qui peut écrire': 'Who can write',
  'Qui peut écrire à la liste': 'Who can write to the list',
  Refuser: 'Decline',
  'Renouveler le défi': 'Renew the challenge',
  'Renvoyer l’invitation': 'Resend the invitation',
  Ressource: 'Resource',
  'Reçus de règlement': 'Payment receipts',
  'Routage prêt': 'Routing ready',
  'Routage à configurer': 'Routing to configure',
  'Règlement requis avant activation.': 'Payment required before activation.',
  'Règlement reçu et vérifié': 'Payment received and verified',
  'Règles et absence (Sieve)': 'Rules and out of office (Sieve)',
  Réactiver: 'Reactivate',
  'Réenrôlement attendu': 'Re-enrolment expected',
  'Référence de la commande confirmée': 'Confirmed order reference',
  'Référence commerciale': 'Commercial reference',
  'Référence de la vérification effectuée': 'Reference of the verification carried out',
  'Référence unique du paiement': 'Unique payment reference',
  'Régularisation sur la prochaine facture.': 'Settled on the next invoice.',
  'Régularisations à facturer : {amount} HT.': 'Adjustments to invoice: {amount} before tax.',
  'Réinitialisation en cours': 'Reset in progress',
  Répartition: 'Allocation',
  'Réponse :': 'Response:',
  'Réservé à l’opérateur après vérification du paiement. Ce formulaire n’effectue aucun débit.':
    'For the operator, after checking the payment. This form charges nothing.',
  'Résiliation prévue au {date}. Ensuite : consultation et export pendant 30 jours.':
    'Termination scheduled for {date}. After that: reading and export for 30 days.',
  'Résilier à la fin de la période payée': 'Terminate at the end of the paid period',
  'Révision {revision} · {units} unités · Catalogue {version} ·':
    'Revision {revision} · {units} units · Catalogue {version} ·',
  Rôle: 'Role',
  Service: 'Service',
  'Service commercial': 'Sales team',
  Solde: 'Balance',
  'Soumettre au second opérateur': 'Submit to the second operator',
  'Souscription enregistrée, sans traitement de paiement.':
    'Subscription recorded, with no payment processing.',
  'Souscriptions des organisations': 'Organisation subscriptions',
  Statut: 'Status',
  Stockage: 'Storage',
  'Stockage commun': 'Shared storage',
  'Stockage commun inclus': 'Shared storage included',
  'Total HT': 'Total before tax',
  'Suivez la transmission des invitations et l’activation des collaborateurs.':
    'Follow how invitations are delivered and colleagues activated.',
  'Suivez les créations et modifications transmises aux services de messagerie et d’identité.':
    'Follow the creations and changes sent to the mail and identity services.',
  'Supprimer cette liste': 'Delete this list',
  'Supprimer l’alias {address}': 'Delete the alias {address}',
  'Supprimer l’alias {address} ? Les futurs messages envoyés à cette adresse seront refusés.':
    'Delete the alias {address}? Future messages sent to that address will be refused.',
  'sur {n} comptes': 'of {n} accounts',
  Suspendre: 'Suspend',
  'Suspendre l’accès de {name} ? Ses sessions seront révoquées. La réception des messages continuera.':
    'Suspend access for {name}? Their sessions will be revoked. Incoming messages will keep arriving.',
  Suspendu: 'Suspended',
  'synchronisation en attente — les anciens droits peuvent encore être actifs':
    'synchronisation pending — the previous rights may still be active',
  Synchronisé: 'Synchronised',
  synchronisé: 'synchronised',
  'Sélectionner {name}': 'Select {name}',
  'Sélectionnez la valeur pour la copier.': 'Select the value to copy it.',
  'Sélectionnez le lien pour le copier.': 'Select the link to copy it.',
  'Taux de taxe validé (%)': 'Approved tax rate (%)',
  Terminée: 'Completed',
  Total: 'Total',
  'Total : {total}': 'Total: {total}',
  'Total HT : {net} · Taxe ({rate} %) : {tax}': 'Total before tax: {net} · Tax ({rate}%): {tax}',
  'Transmettez ce lien à': 'Pass this link on to',
  'Un alias reçoit les messages dans une boîte existante.':
    'An alias receives messages into an existing mailbox.',
  'Un espace bien administré.': 'A well-run workspace.',
  'Une adresse pour toute l’équipe': 'One address for the whole team',
  'Une adresse, plusieurs possibilités': 'One address, several uses',
  'Une liste interne distribue chaque message à ses membres, boîtes nominatives ou partagées de votre organisation, sans unité ni quota supplémentaire. Cent membres au maximum.':
    'An internal list delivers every message to its members, named or shared mailboxes of your organisation, with no extra unit or quota. One hundred members at most.',
  'Une unité correspond à une boîte nominative. Les alias sont inclus.':
    'One unit covers one named mailbox. Aliases are included.',
  'Cette confirmation active le service. Aucun moyen de paiement ne sera débité depuis cet écran.':
    'This confirmation activates the service. No payment method will be charged from this screen.',
  'Ex. DEVIS-2026-001': 'E.g. QUOTE-2026-001',
  'Nombre de boîtes email': 'Number of email mailboxes',
  'Numéro du devis, du bon de commande ou du règlement déjà vérifié.':
    'Number of the quote, purchase order or verified payment.',
  'Retirer une boîte': 'Remove a mailbox',
  'VENAME MAIL ESSENTIAL': 'VENAME MAIL ESSENTIAL',
  'Vérifier la souscription': 'Review the subscription',
  'Vérifiez le récapitulatif avant d’attribuer les droits de service.':
    'Review the summary before granting service access.',
  'Économisez {amount}': 'Save {amount}',
  '{storage} supplémentaires': '{storage} extra',
  'Une liste interne distribue chaque message à ses membres.':
    'An internal list delivers every message to its members.',
  'Une unité couvre une boîte nominative. Un alias n’ajoute ni unité ni stockage. Les unités vacantes restent souscrites ; la réduction à échéance sera traitée avec la facturation.':
    'One unit covers one named mailbox. An alias adds neither a unit nor storage. Vacant units stay subscribed; reducing them at the end of the period is handled with billing.',
  'Une unité disponible sera attribuée et le nouveau titulaire devra activer son compte.':
    'An available unit will be allocated and the new holder will have to activate their account.',
  'Unités au renouvellement': 'Units at renewal',
  'Unités souscrites': 'Subscribed units',
  Utilisateur: 'User',
  Utilisé: 'Used',
  'Utilisé :': 'Used:',
  'Valeur copiée.': 'Value copied.',
  'Valeur observée : {value}': 'Observed value: {value}',
  'Vename Mail {plan} · {subscribed} unités souscrites · {assigned} attribuées · {available} disponibles':
    'Vename Mail {plan} · {subscribed} units subscribed · {assigned} allocated · {available} available',
  'Vename Mail — Facture VM-{number}': 'Vename Mail — Invoice VM-{number}',
  Virement: 'Bank transfer',
  'Volume utilisé': 'Volume used',
  'Volumes issus de la dernière synchronisation de chaque boîte avec le serveur mail.':
    'Volumes taken from the last synchronisation of each mailbox with the mail server.',
  'Vos domaines professionnels': 'Your business domains',
  'Votre capacité souscrite': 'Your subscribed capacity',
  'Vous recevrez les enregistrements DNS pour prouver la propriété du domaine et configurer sa messagerie.':
    'You will receive the DNS records that prove ownership of the domain and configure its mail.',
  'Vous répondez en tant que': 'You are responding as',
  'Vérification du domaine requise': 'Domain verification required',
  'Vérification du domaine terminée.': 'Domain verification complete.',
  'Vérifier maintenant': 'Check now',
  'Vérifiez l’identité par le canal indépendant de l’entreprise. Un second opérateur devra approuver ; cette approbation révoque les accès existants.':
    "Verify the identity through the company's independent channel. A second operator must approve; that approval revokes existing access.",
  Vérifié: 'Verified',
  'Vérifié le {date}': 'Verified on {date}',
  '{date} — {amount} · {method} · Référence {reference}':
    '{date} — {amount} · {method} · Reference {reference}',
  '{days} jours': '{days} days',
  '{n} actifs': '{n} active',
  '{n} délégué(s)': '{n} delegate(s)',
  '{n} prêts': '{n} ready',
  '{samples} mesures de disponibilité de l’API · {days} jours observés · qualification de production en attente.':
    '{samples} API availability measurements · {days} days observed · production qualification pending.',
  '{storage} · Révision {revision}': '{storage} · Revision {revision}',
  '· Envois réservés : {reserved} · Pool :': '· Reserved for sending: {reserved} · Pool:',
  'À approuver': 'To approve',
  'À configurer': 'To set up',
  'À reprendre': 'To retry',
  'À réexaminer': 'To review again',
  'À vérifier': 'To verify',
  Échec: 'Failed',
  Échéance: 'Due date',
  'Écritures à rapprocher : {n}.': 'Writes to reconcile: {n}.',
  Émetteur: 'Issuer',
  'Émetteur : raison sociale, adresse, identifiants fiscaux':
    'Issuer: legal name, address, tax identifiers',
  'Émettre le complément anticipé': 'Issue the prepaid add-on',
  'Émettre un complément consolidé': 'Issue a consolidated add-on',
  'Émise le {created} · Échéance : {due}': 'Issued on {created} · Due {due}',
  'Équipe commerciale': 'Sales team',
  État: 'Status',
  'États des envois': 'Delivery status',

  // Libellés qui parviennent au traducteur par une variable (onglets, droits, politiques, états).
  'Abonnement et stockage': 'Subscription and storage',
  'Consultation et export': 'Reading and export',
  'Contact indépendant de l’administrateur': "The administrator's independent contact",
  'Envoyer au nom de': 'Send on behalf of',
  'Envoyer en tant que': 'Send as',
  'Facturation non activée': 'Billing not enabled',
  'Fin de conservation à traiter': 'End of retention to handle',
  'Gérer les messages et dossiers': 'Manage messages and folders',
  Invitations: 'Invitations',
  'Journal d’activité': 'Activity log',
  'Les membres de la liste': 'The members of the list',
  Lire: 'Read',
  'Nom de l’administrateur': 'Administrator name',
  'Nom de l’organisation': 'Organisation name',
  'Règlement attendu': 'Payment expected',
  'Référence de commande': 'Order reference',
  'Supprimer les messages': 'Delete messages',
  Synchronisation: 'Synchronisation',
  'Tout expéditeur, y compris externe': 'Any sender, including external',
  'Toute votre organisation': 'Your whole organisation',
  'À jour': 'Up to date',
  'Émission suspendue': 'Sending suspended',
  'VOTRE ORGANISATION': 'YOUR ORGANISATION',
  'CONSOLE VENAME': 'VENAME CONSOLE',
  o: 'B',
  '{used} sur {total}': '{used} of {total}',
  '{index} sur {total}': '{index} of {total}',
  'Langue des courriels et de l’invitation': 'Language of emails and of the invitation',
  'Limites d’usage': 'Usage limits',
  '{aliases} alias par boîte · {domains} domaines':
    '{aliases} aliases per mailbox · {domains} domains',
  'Limites d’usage — {name}': 'Usage limits — {name}',
  'Limites d’usage enregistrées.': 'Usage limits saved.',
  'Le catalogue prévoit 30 alias par boîte et 10 domaines raccordés par organisation. Relevez ces limites sans frais après avoir vérifié un usage légitime ; une limite abaissée conserve les alias et domaines existants.':
    'The catalogue includes 30 aliases per mailbox and 10 connected domains per organisation. Raise these limits free of charge after checking a legitimate use; a lowered limit keeps the existing aliases and domains.',
  'Alias par boîte': 'Aliases per mailbox',
  'Domaines raccordés': 'Connected domains',
  '{n} domaines raccordés sur {max} inclus.': '{n} of {max} included domains connected.',
  'Jusqu’à {max} alias par boîte.': 'Up to {max} aliases per mailbox.',
  'Votre organisation a atteint {max} domaines raccordés. Au-delà, Vename qualifie votre besoin sans frais : contactez le support.':
    'Your organisation has reached {max} connected domains. Beyond that, Vename reviews your need free of charge: contact support.',
  'Cette boîte a atteint {max} alias. Au-delà, Vename vérifie l’usage et relève la limite sans frais : contactez le support.':
    'This mailbox has reached {max} aliases. Beyond that, Vename checks the use and raises the limit free of charge: contact support.',
  'Votre boîte est pleine : les nouveaux messages sont refusés temporairement jusqu’à ce que vous libériez de l’espace. Videz la corbeille, archivez ou demandez à votre administrateur d’augmenter votre plafond.':
    'Your mailbox is full: new messages are temporarily refused until you free up space. Empty the bin, archive, or ask your administrator to raise your cap.',
  'Votre boîte utilise plus de 90 % de son quota. Videz la corbeille ou supprimez des pièces jointes volumineuses : à 100 %, les nouveaux messages seront refusés.':
    'Your mailbox uses more than 90% of its quota. Empty the bin or delete large attachments: at 100%, new messages will be refused.',
  '{percent} % utilisés': '{percent}% used',
  '{n} messages affichés': '{n} messages shown',
  '{n} messages': '{n} messages',
  '{n} message': '{n} message',
  '{n} libellé(s) créé(s) depuis les groupes': '{n} label(s) created from groups',
  '{n} groupe(s) non repris : limite de libellés atteinte':
    '{n} group(s) not imported: label limit reached',
  'Mes événements': 'My events',
  'Invitations reçues': 'Invitations received',
  Événement: 'Event',
  '{n} occurrences': '{n} occurrences',
  'Invitation v{n} :': 'Invitation v{n}:',
  remplacée: 'replaced',
  BÊTA: 'BETA',
  partagée: 'shared',
  'Votre réponse d’absence est active': 'Your out-of-office reply is on',
  À: 'To',
  moi: 'me',
  'De : {v}': 'From: {v}',
  'À : {v}': 'To: {v}',
  'Cc : {v}': 'Cc: {v}',
  'Cci : {v}': 'Bcc: {v}',
  '{n} pièces jointes': '{n} attachments',
  '{n} pièce jointe': '{n} attachment',
  'État : {status}': 'Status: {status}',
  'Supprimer le dossier « {name} » ? Ses {n} message(s) seront déplacés vers la corbeille.':
    'Delete the folder “{name}”? Its {n} message(s) will be moved to the bin.',
  '{name} sera retiré de votre carnet. Vos messages échangés ne sont pas supprimés.':
    '{name} will be removed from your address book. The messages you exchanged are not deleted.',
  'Cet envoi est programmé le {date}. Annulez la programmation pour modifier ce message.':
    'This message is scheduled for {date}. Cancel the scheduling to edit it.',
  'Dernière activité : {date}': 'Last activity: {date}',
  'Adresse IP : {ip}': 'IP address: {ip}',
  'Les fonctions de collaboration Pro ne sont pas activées.':
    'Pro collaboration features are not enabled.',
  'Seul un administrateur peut modifier l’annuaire partagé.':
    'Only an administrator can edit the shared directory.',
  'Seul un administrateur peut gérer les modèles et la signature.':
    'Only an administrator can manage templates and the company signature.',
  'Modèle introuvable.': 'Template not found.',
  'Modèles d’équipe et signature d’entreprise': 'Team templates and company signature',
  'Les modèles sont accessibles à tous les membres. La signature d’entreprise s’ajoute aux nouveaux messages rédigés dans le webmail.':
    'Templates are available to every member. The company signature is added to new messages written in webmail.',
  'Modèles disponibles': 'Available templates',
  'Sans objet prédéfini': 'No preset subject',
  'Modèle supprimé.': 'Template deleted.',
  'Aucun modèle pour le moment.': 'No templates yet.',
  'Modèle enregistré.': 'Template saved.',
  'Modifier le modèle': 'Edit template',
  'Créer un modèle': 'Create template',
  'Nom du modèle': 'Template name',
  'Réponse commerciale': 'Sales reply',
  'Objet proposé': 'Suggested subject',
  'Contenu du message': 'Message content',
  'Bonjour, …': 'Hello, …',
  'Enregistrer le modèle': 'Save template',
  'Signature d’entreprise enregistrée.': 'Company signature saved.',
  'Signature d’entreprise': 'Company signature',
  Signature: 'Signature',
  'Texte simple ou HTML. Le contenu HTML est nettoyé avant son affichage et son envoi.':
    'Plain text or HTML. HTML content is sanitized before display and sending.',
  'L’équipe Vename Mail': 'The Vename Mail team',
  'Enregistrer la signature': 'Save signature',
  'Modèle d’équipe': 'Team template',
  'Modèles d’équipe': 'Team templates',
  'Modèle d’équipe créé': 'Team template created',
  'Modèle d’équipe modifié': 'Team template updated',
  'Modèle d’équipe supprimé': 'Team template deleted',
  'Signature d’entreprise modifiée': 'Company signature updated',
  '180 derniers jours': 'Last 180 days',
  'Choisir un modèle': 'Choose a template',
  Insérer: 'Insert',
  'Cette adresse existe déjà dans l’annuaire.': 'This address already exists in the directory.',
  'Droit administrateur requis.': 'Administrator access is required.',
  'Calendrier introuvable ou droit insuffisant.': 'Calendar not found or insufficient access.',
  'Le propriétaire conserve ses droits.': 'The owner keeps their access rights.',
  'Membre actif introuvable.': 'Active member not found.',
  'Version de l’événement requise.': 'The event version is required.',
  'Événement modifié ou supprimé. Actualisez le calendrier.':
    'The event was changed or deleted. Refresh the calendar.',
  'Événement modifié ou supprimé.': 'The event was changed or deleted.',
  'Le suivi collaboratif concerne une boîte partagée.':
    'Collaborative tracking requires a shared mailbox.',
  'Attribution modifiée. Actualisez le suivi.':
    'The assignment changed. Refresh the tracking panel.',
  'Espace d’équipe': 'Team workspace',
  'Annuaire commun et calendriers partagés de votre organisation.':
    'Shared directory and team calendars for your organization.',
  'Les fonctions Pro ne sont pas encore activées pour cette organisation.':
    'Pro features are not enabled for this organization yet.',
  'Annuaire partagé': 'Shared directory',
  'Membre de l’organisation': 'Organization member',
  'Supprimer le contact': 'Delete contact',
  'Ajouter un contact commun': 'Add a shared contact',
  'Ajouter à l’annuaire': 'Add to directory',
  'Calendriers d’équipe': 'Team calendars',
  'Nom du nouveau calendrier': 'New calendar name',
  'Créer le calendrier': 'Create calendar',
  'Calendrier à consulter': 'Calendar to display',
  'Choisir un calendrier': 'Choose a calendar',
  'Événements des 30 derniers jours et des 60 prochains jours. Heures affichées dans votre fuseau local.':
    'Events from the last 30 days and next 60 days. Times are shown in your local timezone.',
  'Modifier l’événement': 'Edit event',
  'Partager le calendrier': 'Share calendar',
  Membre: 'Member',
  'Choisir un membre': 'Choose a member',
  Droit: 'Access',
  'Consulter et modifier': 'View and edit',
  'Retirer l’accès': 'Revoke access',
  'Appliquer le partage': 'Apply sharing',
  'Suivi interne de ce message': 'Internal tracking for this message',
  'Attribué à': 'Assigned to',
  'Non attribué': 'Unassigned',
  'Les notes restent dans la boîte partagée et ne sont pas envoyées aux destinataires.':
    'Notes remain in the shared mailbox and are not sent to recipients.',
  'Nouvelle note interne': 'New internal note',
  'Ajouter la note': 'Add note',
  'Collaboration Pro pilote': 'Pro collaboration pilot',
  'Désactiver le pilote Pro': 'Disable Pro pilot',
  'Activer le pilote Pro': 'Enable Pro pilot',
  'Collaboration Pro désactivée.': 'Pro collaboration disabled.',
  'Collaboration Pro activée pour le pilote.': 'Pro collaboration enabled for the pilot.',
  'Cette conversation dépasse la limite de 1 000 messages.':
    'This conversation exceeds the 1,000 message limit.',
  'Suivi interne de la conversation': 'Internal conversation tracking',
  'Conversation : {count} message(s)': 'Conversation: {count} message(s)',
  'Messages de la conversation': 'Conversation messages',
  'Attribution à revoir : accès révoqué': 'Assignment needs review: access revoked',
  'Le webhook exige un domaine public en HTTPS sur le port 443.':
    'The webhook requires a public HTTPS domain on port 443.',
  'Le domaine du webhook ne pointe pas uniquement vers des adresses publiques IPv4.':
    'The webhook domain must resolve only to public IPv4 addresses.',
  'Clé introuvable.': 'Key not found.',
  'Clé API requise.': 'API key required.',
  'Clé API indisponible ou portée insuffisante.': 'API key unavailable or scope insufficient.',
  'Webhook introuvable.': 'Webhook not found.',
  'Une clé partenaire n’ouvre que l’API partenaire.': 'A partner key only opens the partner API.',
  'L’API partenaire n’accepte aucun cookie.': 'The partner API accepts no cookie.',
  'Signature partenaire absente ou mal formée.': 'Partner signature missing or malformed.',
  'Horodatage de la requête hors de la fenêtre autorisée.':
    'Request timestamp outside the allowed window.',
  'Clé partenaire inconnue ou révoquée.': 'Partner key unknown or revoked.',
  'Signature partenaire invalide.': 'Invalid partner signature.',
  'L’API partenaire est momentanément indisponible.': 'The partner API is temporarily unavailable.',
  'Adresse IP source non déclarée pour cette clé.': 'Source IP address not declared for this key.',
  'Trop de requêtes pour cette clé partenaire.': 'Too many requests for this partner key.',
  'Ce nonce a déjà été utilisé.': 'This nonce has already been used.',
  'Le corps de la requête doit être du JSON valide.': 'The request body must be valid JSON.',
  'Le corps de la requête dépasse 64 Kio.': 'The request body exceeds 64 KiB.',
  'Le corps de la requête est illisible.': 'The request body cannot be read.',
  'Commande introuvable.': 'Order not found.',
  'Le SSO exige l’identité sécurisée Vename Mail.': 'SSO requires Vename Mail secure identity.',
  'Configurez d’abord Microsoft Entra ID.': 'Configure Microsoft Entra ID first.',
  'Liaison SSO introuvable.': 'SSO link not found.',
  'Microsoft Entra ID doit confirmer le tenant, l’identité et la MFA.':
    'Microsoft Entra ID must confirm the tenant, identity and MFA.',
  'Connexion SSO indisponible.': 'SSO sign-in is unavailable.',
  'Aucune connexion Microsoft Entra ID pour ce domaine.':
    'No Microsoft Entra ID sign-in is configured for this domain.',
  'Utilisez d’abord votre connexion Vename Mail avec MFA.':
    'Sign in to Vename Mail with MFA first.',
  'Microsoft Entra ID n’est pas activé pour cette organisation.':
    'Microsoft Entra ID is not enabled for this organization.',
  'Connexion SSO expirée.': 'SSO sign-in expired.',
  'Connexion SSO expirée ou déjà utilisée.': 'SSO sign-in expired or was already used.',
  'Cette configuration SSO a changé.': 'This SSO configuration has changed.',
  'La connexion Microsoft Entra ID a échoué. Relancez-la.':
    'Microsoft Entra ID sign-in failed. Start again.',
  'Microsoft Entra ID n’a pas confirmé l’identité.':
    'Microsoft Entra ID did not confirm the identity.',
  'Reconnectez-vous à Vename Mail avant de lier le compte.':
    'Sign in to Vename Mail again before linking the account.',
  'Liez d’abord ce compte Microsoft depuis votre session Vename Mail.':
    'Link this Microsoft account from your Vename Mail session first.',
  'La session SSO a été révoquée. Reconnectez-vous.': 'The SSO session was revoked. Sign in again.',
  'Intégrations Pro': 'Pro integrations',
  'Vos intégrations métier': 'Your business integrations',
  'Gérez les clés API et les webhooks de votre organisation.':
    'Manage your organization’s API keys and webhooks.',
  'Connexion Microsoft Entra ID de mon entreprise': 'My company’s Microsoft Entra ID sign-in',
  'Domaine de votre adresse professionnelle': 'Your work email domain',
  'Domaine ou adresse professionnelle': 'Work email domain or address',
  'Exemple : entreprise.ci ou nom@entreprise.ci.': 'Example: company.com or name@company.com.',
  'Indiquez un domaine ou une adresse professionnelle valide.':
    'Enter a valid work email domain or address.',
  'Aucune connexion Microsoft n’est configurée pour ce domaine. Vérifiez-le ou contactez votre administrateur.':
    'Microsoft sign-in is not configured for this domain. Check it or contact your administrator.',
  'Trop de tentatives. Réessayez dans quelques minutes.':
    'Too many attempts. Try again in a few minutes.',
  'La connexion Microsoft est momentanément indisponible. Réessayez.':
    'Microsoft sign-in is temporarily unavailable. Try again.',
  'La date de fin doit suivre la date de début.': 'The end date must be after the start date.',
  'Période incorrecte': 'Invalid date range',
  'Adresse secondaire invalide à la ligne {n}. Utilisez le format nom@domaine.ci.':
    'Invalid secondary address on line {n}. Use the format name@company.com.',
  'Ajoutez au maximum dix adresses secondaires.': 'Add no more than ten secondary addresses.',
  'Pièce jointe envoyée': 'Sent attachment',
  'Pièce jointe reçue': 'Received attachment',
  'Statut d’analyse antivirus indisponible': 'Antivirus scan status unavailable',
  'Analyse antivirus terminée': 'Antivirus scan completed',
  'Analyse antivirus en attente': 'Antivirus scan pending',
  'Pièce jointe bloquée': 'Attachment blocked',
  'Vos règles seront appliquées aux prochains messages après synchronisation.':
    'Your rules will apply to new messages after synchronisation.',
  'Votre réponse d’absence sera active après synchronisation.':
    'Your away reply will become active after synchronisation.',
  'Écrire au support Vename depuis une autre adresse email':
    'Email Vename support from another email address',
  'Besoin d’une aide humaine ?': 'Need help from a person?',
  'Écrivez au support Vename, même depuis une adresse extérieure à votre organisation.':
    'Email Vename support, even from an address outside your organisation.',
  'Contacter le support Vename': 'Contact Vename support',
  'Votre organisation n’a pas encore activé les fonctions d’équipe. Vous pourrez y retrouver l’annuaire commun et les calendriers partagés.':
    'Your organisation has not activated team features yet. They include the shared directory and team calendars.',
  'Demandez l’activation à votre administrateur ou contactez le support Vename.':
    'Ask your administrator to request activation or contact Vename support.',
  'Écrire au support': 'Email support',
  'Continuer avec Microsoft': 'Continue with Microsoft',
  'Créez des accès en lecture pour vos outils métier et recevez les événements choisis. Les secrets ne sont affichés qu’une seule fois.':
    'Create read-only access for your business tools and receive selected events. Secrets are shown only once.',
  'Copiez ce secret maintenant : il ne sera plus visible.':
    'Copy this secret now: it will not be shown again.',
  'Connexion Microsoft Entra ID': 'Microsoft Entra ID sign-in',
  'Enregistrez une application web dans Microsoft Entra ID, ajoutez l’URL de retour ci-dessous et activez la MFA ainsi que la revendication AMR dans les jetons ID. Chaque membre lie ensuite son compte depuis Sécurité et sessions.':
    'Register a web application in Microsoft Entra ID, add the callback URL below, and enable MFA and the AMR claim in ID tokens. Each member then links their account from Security and sessions.',
  'URL de retour :': 'Callback URL:',
  'SSO actif': 'SSO enabled',
  'SSO configuré, à activer': 'SSO configured, awaiting activation',
  'SSO non configuré': 'SSO not configured',
  'ID du tenant Entra': 'Entra tenant ID',
  'ID de l’application cliente': 'Application client ID',
  'Secret client': 'Client secret',
  'Enregistrer la configuration SSO': 'Save SSO configuration',
  'Désactiver le SSO': 'Disable SSO',
  'Activer le SSO': 'Enable SSO',
  'Comptes Microsoft liés': 'Linked Microsoft accounts',
  'Révoquer la liaison': 'Revoke link',
  'Clés API': 'API keys',
  'Nouvelle clé API': 'New API key',
  'Nom de l’intégration': 'Integration name',
  'Accès autorisés': 'Allowed access',
  'Créer une clé valable 30 jours': 'Create a key valid for 30 days',
  'Expire le': 'Expires on',
  Révoquée: 'Revoked',
  Webhooks: 'Webhooks',
  'Secret de signature du webhook': 'Webhook signing secret',
  'URL HTTPS publique': 'Public HTTPS URL',
  'Événements envoyés': 'Events to send',
  'Créer un webhook': 'Create webhook',
  'Connexion Microsoft de votre organisation': 'Your organization’s Microsoft sign-in',
  'Si votre administrateur a activé Microsoft Entra ID, liez votre identité Microsoft à ce compte Vename Mail depuis cette session protégée.':
    'If your administrator enabled Microsoft Entra ID, link your Microsoft identity to this Vename Mail account from this protected session.',
  'Lier mon compte Microsoft': 'Link my Microsoft account',
  '{n} messages déplacés dans la corbeille.': '{n} messages moved to the bin.',
  '{n} messages archivés.': '{n} messages archived.',
  '{n} messages restaurés dans la réception.': '{n} messages restored to the inbox.',
  '{n} messages supprimés définitivement.': '{n} messages permanently deleted.',
  'Message supprimé définitivement.': 'Message permanently deleted.',
  'Restaurer la sélection dans la réception': 'Restore selection to inbox',
  'Supprimer définitivement la sélection': 'Permanently delete selection',
  'Déplacer la sélection dans la corbeille': 'Move selection to bin',
  'Déplacer ce contact dans la corbeille': 'Move this contact to bin',
  'Déplacer dans la corbeille': 'Move to bin',
  '{n} contacts déplacés dans la corbeille.': '{n} contacts moved to the bin.',
  '{n} contact déplacé dans la corbeille.': '{n} contact moved to the bin.',
  '{n} contact(s) seront déplacés dans la corbeille. Vous pourrez les restaurer pendant 30 jours. Vos messages échangés seront conservés.':
    '{n} contact(s) will be moved to the bin. You can restore them for 30 days. Your exchanged messages will be kept.',
  '{name} sera déplacé dans la corbeille. Vous pourrez le restaurer pendant 30 jours. Vos messages échangés seront conservés.':
    '{name} will be moved to the bin. You can restore this contact for 30 days. Your exchanged messages will be kept.',
  'Suppression…': 'Deleting…',
  'Supprimer définitivement ce contact': 'Permanently delete this contact',
  '{name} sera supprimé définitivement. Cette action ne pourra pas être annulée.':
    '{name} will be permanently deleted. This action cannot be undone.',
  'La désactivation de votre réponse d’absence sera transmise au serveur après enregistrement.':
    'Disabling your out-of-office reply will be sent to the server after saving.',
  'La facturation de cette organisation n’est pas tenue par le site Vename.':
    'This organisation is not billed by the Vename website.',
  'La facturation de cette organisation est tenue par le site Vename.':
    'This organisation is billed by the Vename website.',
  'La fin de période précède son début.': 'The period ends before it starts.',
  'Cette référence est déjà enregistrée avec un autre contenu.':
    'This reference is already recorded with different content.',
  'Le remboursement dépasse les paiements enregistrés pour cette facture.':
    'The refund exceeds the payments recorded for this invoice.',
  'La facturation de la plateforme est déjà activée pour cette organisation.':
    'Platform billing is already enabled for this organisation.',
  'Les conditions commerciales de cette organisation sont déjà enregistrées.':
    'The commercial terms of this organisation are already recorded.',
  'Le nombre de boîtes commandées est inférieur aux {count} boîtes déjà créées.':
    'The number of mailboxes ordered is lower than the {count} mailboxes already created.',
  'Cette organisation a déjà un abonnement : modifiez la commande.':
    'This organisation already has a subscription: change the order instead.',
  'Cette organisation est résiliée.': 'This organisation is cancelled.',
  'Aucun abonnement à modifier.': 'There is no subscription to change.',
  'Une baisse prend effet à la période suivante (effective : next_period).':
    'A decrease takes effect at the next period (effective: next_period).',
  'Date de résiliation invalide.': 'Invalid cancellation date.',
  'La résiliation a déjà pris effet.': 'The cancellation has already taken effect.',
  'En-tête Idempotency-Key obligatoire (8 à 128 caractères).':
    'The Idempotency-Key header is required (8 to 128 characters).',
  'Cette clé d’idempotence a déjà servi pour une autre requête.':
    'This idempotency key was already used for another request.',
  'Ce domaine est déjà servi pour une autre organisation.':
    'This domain is already served for another organisation.',
  'L’adresse de contact doit être extérieure au domaine commandé.':
    'The contact address must be outside the ordered domain.',
  'Ce domaine est en cours de validation par une autre commande jusqu’au {releaseAt}.':
    'This domain is being validated by another order until {releaseAt}.',
  'Cette commande a expiré faute de preuve du domaine.':
    'This order expired because the domain was not proven.',
  'Ce compte est suspendu : réactivez-le avant de préparer sa récupération.':
    'This account is suspended: reactivate it before preparing its recovery.',
  'Invitation envoyée.': 'Invitation sent.',
  'Le corps de la requête est trop volumineux.': 'The request body is too large.',
  'En attente d’un second opérateur': 'Awaiting a second operator',
  'Approuver l’invitation': 'Approve the invitation',
  'Opérateur à inviter': 'Operator to invite',
  'Demande transmise : un second opérateur doit l’approuver.':
    'Request submitted: a second operator must approve it.',
  'Une facture couvre au plus une année.': 'An invoice covers at most one year.',
  'Cette facture a été annulée.': 'This invoice was cancelled.',
  'Remboursez d’abord les paiements de cette facture.':
    'Refund the payments of this invoice first.',
  'La date de résiliation est déjà passée.': 'The cancellation date has already passed.',
  'Utilisez des lettres minuscules, des chiffres et les signes . _ + -, en commençant par une lettre ou un chiffre.':
    'Use lowercase letters, digits and the signs . _ + -, starting with a letter or a digit.',
  'Réponse de téléversement invalide.': 'Invalid upload response.',
  'Téléversement impossible.': 'Upload failed.',
  'Connexion interrompue pendant le téléversement.': 'Connection lost during the upload.',
  'Votre session a expiré. Copiez votre texte, puis reconnectez-vous.':
    'Your session expired. Copy your text, then sign in again.',
  '1 octet': '1 byte',
  'Révoquer {name} ? Les applications qui l’utilisent seront déconnectées.':
    'Revoke {name}? The applications using it will be disconnected.',
  'Révoquer {name}': 'Revoke {name}',
  'Copie impossible : sélectionnez le secret pour le copier.':
    'Copy failed: select the secret to copy it.',
  'Approuver cette récupération ? Les accès existants de {email} seront révoqués.':
    'Approve this recovery? The existing access of {email} will be revoked.',
  Agrandir: 'Expand',
  'Retirer {name}': 'Remove {name}',
  '(sans objet)': '(no subject)',
  'Le message « {subject} » ne sera pas envoyé. Son brouillon reste dans vos brouillons.':
    'The message “{subject}” will not be sent. Its draft stays in your drafts.',
  '{count} boîte(s), formule {plan}, {price} / {period}':
    '{count} mailbox(es), {plan} plan, {price} / {period}',
  'Changement prévu au {date} : {terms}.': 'Change scheduled for {date}: {terms}.',
  'Changement prévu au {date} en attente : {terms}. L’organisation dépasse encore cette capacité ; il s’appliquera dès qu’elle y tiendra.':
    'Change scheduled for {date} is pending: {terms}. The organisation still exceeds this capacity; it will apply as soon as it fits.',
  '{assigned} boîtes sont attribuées pour {count} prévues : supprimez-en {excess} avant le {date}, sinon le changement restera en attente.':
    '{assigned} mailboxes are assigned for {count} planned: delete {excess} before {date}, otherwise the change will stay pending.',
};
export default en;
